(function(global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('jquery'), require('popper.js')) :
        typeof define === 'function' && define.amd ? define(['jquery', 'popper.js'], factory) :
        (factory(global.jQuery, global.Popper));
}(this, (function($, Popper$1) {
    'use strict';

    $ = $ && $.hasOwnProperty('default') ? $['default'] : $;
    Popper$1 = Popper$1 && Popper$1.hasOwnProperty('default') ? Popper$1['default'] : Popper$1;

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }

    function _extends() {
        _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];

                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }

            return target;
        };

        return _extends.apply(this, arguments);
    }

    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): util.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Util = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Private TransitionEnd Helpers
         * ------------------------------------------------------------------------
         */
        var transition = false;
        var MAX_UID = 1000000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

        function toType(obj) {
            return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
        }

        function getSpecialTransitionEndEvent() {
            return {
                bindType: transition.end,
                delegateType: transition.end,
                handle: function handle(event) {
                    if ($$$1(event.target).is(this)) {
                        return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                    }

                    return undefined; // eslint-disable-line no-undefined
                }
            };
        }

        function transitionEndTest() {
            if (typeof window !== 'undefined' && window.QUnit) {
                return false;
            }

            return {
                end: 'transitionend'
            };
        }

        function transitionEndEmulator(duration) {
            var _this = this;

            var called = false;
            $$$1(this).one(Util.TRANSITION_END, function() {
                called = true;
            });
            setTimeout(function() {
                if (!called) {
                    Util.triggerTransitionEnd(_this);
                }
            }, duration);
            return this;
        }

        function setTransitionEndSupport() {
            transition = transitionEndTest();
            $$$1.fn.emulateTransitionEnd = transitionEndEmulator;

            if (Util.supportsTransitionEnd()) {
                $$$1.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
            }
        }
        /**
         * --------------------------------------------------------------------------
         * Public Util Api
         * --------------------------------------------------------------------------
         */


        var Util = {
            TRANSITION_END: 'bsTransitionEnd',
            getUID: function getUID(prefix) {
                do {
                    // eslint-disable-next-line no-bitwise
                    prefix += ~~(Math.random() * MAX_UID); // "~~" acts like secret faster Math.floor() here
                } while (document.getElementById(prefix));

                return prefix;
            },
            getSelectorFromElement: function getSelectorFromElement(element) {
                var selector = element.getAttribute('data-target');

                if (!selector || selector === '#') {
                    selector = element.getAttribute('href') || '';
                }

                try {
                    var $selector = $$$1(document).find(selector);
                    return $selector.length > 0 ? selector : null;
                } catch (err) {
                    return null;
                }
            },
            reflow: function reflow(element) {
                return element.offsetHeight;
            },
            triggerTransitionEnd: function triggerTransitionEnd(element) {
                $$$1(element).trigger(transition.end);
            },
            supportsTransitionEnd: function supportsTransitionEnd() {
                return Boolean(transition);
            },
            isElement: function isElement(obj) {
                return (obj[0] || obj).nodeType;
            },
            typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
                for (var property in configTypes) {
                    if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                        var expectedTypes = configTypes[property];
                        var value = config[property];
                        var valueType = value && Util.isElement(value) ? 'element' : toType(value);

                        if (!new RegExp(expectedTypes).test(valueType)) {
                            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
                        }
                    }
                }
            }
        };
        setTransitionEndSupport();
        return Util;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): alert.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Alert = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'alert';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.alert';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var TRANSITION_DURATION = 150;
        var Selector = {
            DISMISS: '[data-dismiss="alert"]'
        };
        var Event = {
            CLOSE: "close" + EVENT_KEY,
            CLOSED: "closed" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            ALERT: 'alert',
            FADE: 'fade',
            SHOW: 'show'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Alert =
            /*#__PURE__*/
            function() {
                function Alert(element) {
                    this._element = element;
                } // Getters


                var _proto = Alert.prototype;

                // Public
                _proto.close = function close(element) {
                    element = element || this._element;

                    var rootElement = this._getRootElement(element);

                    var customEvent = this._triggerCloseEvent(rootElement);

                    if (customEvent.isDefaultPrevented()) {
                        return;
                    }

                    this._removeElement(rootElement);
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._element = null;
                }; // Private


                _proto._getRootElement = function _getRootElement(element) {
                    var selector = Util.getSelectorFromElement(element);
                    var parent = false;

                    if (selector) {
                        parent = $$$1(selector)[0];
                    }

                    if (!parent) {
                        parent = $$$1(element).closest("." + ClassName.ALERT)[0];
                    }

                    return parent;
                };

                _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
                    var closeEvent = $$$1.Event(Event.CLOSE);
                    $$$1(element).trigger(closeEvent);
                    return closeEvent;
                };

                _proto._removeElement = function _removeElement(element) {
                    var _this = this;

                    $$$1(element).removeClass(ClassName.SHOW);

                    if (!Util.supportsTransitionEnd() || !$$$1(element).hasClass(ClassName.FADE)) {
                        this._destroyElement(element);

                        return;
                    }

                    $$$1(element).one(Util.TRANSITION_END, function(event) {
                        return _this._destroyElement(element, event);
                    }).emulateTransitionEnd(TRANSITION_DURATION);
                };

                _proto._destroyElement = function _destroyElement(element) {
                    $$$1(element).detach().trigger(Event.CLOSED).remove();
                }; // Static


                Alert._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Alert(this);
                            $element.data(DATA_KEY, data);
                        }

                        if (config === 'close') {
                            data[config](this);
                        }
                    });
                };

                Alert._handleDismiss = function _handleDismiss(alertInstance) {
                    return function(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        alertInstance.close(this);
                    };
                };

                _createClass(Alert, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }]);

                return Alert;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Alert._jQueryInterface;
        $$$1.fn[NAME].Constructor = Alert;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Alert._jQueryInterface;
        };

        return Alert;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): button.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Button = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'button';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.button';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var ClassName = {
            ACTIVE: 'active',
            BUTTON: 'btn',
            FOCUS: 'focus'
        };
        var Selector = {
            DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
            DATA_TOGGLE: '[data-toggle="buttons"]',
            INPUT: 'input',
            ACTIVE: '.active',
            BUTTON: '.btn'
        };
        var Event = {
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
            FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY + DATA_API_KEY + " " + ("blur" + EVENT_KEY + DATA_API_KEY)
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Button =
            /*#__PURE__*/
            function() {
                function Button(element) {
                    this._element = element;
                } // Getters


                var _proto = Button.prototype;

                // Public
                _proto.toggle = function toggle() {
                    var triggerChangeEvent = true;
                    var addAriaPressed = true;
                    var rootElement = $$$1(this._element).closest(Selector.DATA_TOGGLE)[0];

                    if (rootElement) {
                        var input = $$$1(this._element).find(Selector.INPUT)[0];

                        if (input) {
                            if (input.type === 'radio') {
                                if (input.checked && $$$1(this._element).hasClass(ClassName.ACTIVE)) {
                                    triggerChangeEvent = false;
                                } else {
                                    var activeElement = $$$1(rootElement).find(Selector.ACTIVE)[0];

                                    if (activeElement) {
                                        $$$1(activeElement).removeClass(ClassName.ACTIVE);
                                    }
                                }
                            }

                            if (triggerChangeEvent) {
                                if (input.hasAttribute('disabled') || rootElement.hasAttribute('disabled') || input.classList.contains('disabled') || rootElement.classList.contains('disabled')) {
                                    return;
                                }

                                input.checked = !$$$1(this._element).hasClass(ClassName.ACTIVE);
                                $$$1(input).trigger('change');
                            }

                            input.focus();
                            addAriaPressed = false;
                        }
                    }

                    if (addAriaPressed) {
                        this._element.setAttribute('aria-pressed', !$$$1(this._element).hasClass(ClassName.ACTIVE));
                    }

                    if (triggerChangeEvent) {
                        $$$1(this._element).toggleClass(ClassName.ACTIVE);
                    }
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._element = null;
                }; // Static


                Button._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        if (!data) {
                            data = new Button(this);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (config === 'toggle') {
                            data[config]();
                        }
                    });
                };

                _createClass(Button, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }]);

                return Button;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function(event) {
            event.preventDefault();
            var button = event.target;

            if (!$$$1(button).hasClass(ClassName.BUTTON)) {
                button = $$$1(button).closest(Selector.BUTTON);
            }

            Button._jQueryInterface.call($$$1(button), 'toggle');
        }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function(event) {
            var button = $$$1(event.target).closest(Selector.BUTTON)[0];
            $$$1(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Button._jQueryInterface;
        $$$1.fn[NAME].Constructor = Button;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Button._jQueryInterface;
        };

        return Button;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0-beta): carousel.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Carousel = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'carousel';
        var VERSION = '4.0.0-beta';
        var DATA_KEY = 'bs.carousel';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var TRANSITION_DURATION = 600;
        var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

        var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

        var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

        var Default = {
            interval: 5000,
            keyboard: true,
            slide: false,
            pause: 'hover',
            wrap: true
        };
        var DefaultType = {
            interval: '(number|boolean)',
            keyboard: 'boolean',
            slide: '(boolean|string)',
            pause: '(string|boolean)',
            wrap: 'boolean'
        };
        var Direction = {
            NEXT: 'next',
            PREV: 'prev',
            LEFT: 'left',
            RIGHT: 'right'
        };
        var Event = {
            SLIDE: "slide" + EVENT_KEY,
            SLID: "slid" + EVENT_KEY,
            KEYDOWN: "keydown" + EVENT_KEY,
            MOUSEENTER: "mouseenter" + EVENT_KEY,
            MOUSELEAVE: "mouseleave" + EVENT_KEY,
            TOUCHEND: "touchend" + EVENT_KEY,
            LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            CAROUSEL: 'carousel',
            ACTIVE: 'active',
            SLIDE: 'slide',
            RIGHT: 'carousel-item-right',
            LEFT: 'carousel-item-left',
            NEXT: 'carousel-item-next',
            PREV: 'carousel-item-prev',
            ITEM: 'carousel-item'
        };
        var Selector = {
            ACTIVE: '.active',
            ACTIVE_ITEM: '.active.carousel-item',
            ITEM: '.carousel-item',
            NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
            INDICATORS: '.carousel-indicators',
            DATA_SLIDE: '[data-slide], [data-slide-to]',
            DATA_RIDE: '[data-ride="carousel"]'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Carousel =
            /*#__PURE__*/
            function() {
                function Carousel(element, config) {
                    this._items = null;
                    this._interval = null;
                    this._activeElement = null;
                    this._isPaused = false;
                    this._isSliding = false;
                    this.touchTimeout = null;
                    this._config = this._getConfig(config);
                    this._element = $$$1(element)[0];
                    this._indicatorsElement = $$$1(this._element).find(Selector.INDICATORS)[0];

                    this._addEventListeners();
                } // getters


                var _proto = Carousel.prototype;

                // public
                _proto.next = function next() {
                    if (!this._isSliding) {
                        this._slide(Direction.NEXT);
                    }
                };

                _proto.nextWhenVisible = function nextWhenVisible() {
                    // Don't call next when the page isn't visible
                    if (!document.hidden) {
                        this.next();
                    }
                };

                _proto.prev = function prev() {
                    if (!this._isSliding) {
                        this._slide(Direction.PREV);
                    }
                };

                _proto.pause = function pause(event) {
                    if (!event) {
                        this._isPaused = true;
                    }

                    if ($$$1(this._element).find(Selector.NEXT_PREV)[0] && Util.supportsTransitionEnd()) {
                        Util.triggerTransitionEnd(this._element);
                        this.cycle(true);
                    }

                    clearInterval(this._interval);
                    this._interval = null;
                };

                _proto.cycle = function cycle(event) {
                    if (!event) {
                        this._isPaused = false;
                    }

                    if (this._interval) {
                        clearInterval(this._interval);
                        this._interval = null;
                    }

                    if (this._config.interval && !this._isPaused) {
                        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
                    }
                };

                _proto.to = function to(index) {
                    var _this = this;

                    this._activeElement = $$$1(this._element).find(Selector.ACTIVE_ITEM)[0];

                    var activeIndex = this._getItemIndex(this._activeElement);

                    if (index > this._items.length - 1 || index < 0) {
                        return;
                    }

                    if (this._isSliding) {
                        $$$1(this._element).one(Event.SLID, function() {
                            return _this.to(index);
                        });
                        return;
                    }

                    if (activeIndex === index) {
                        this.pause();
                        this.cycle();
                        return;
                    }

                    var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

                    this._slide(direction, this._items[index]);
                };

                _proto.dispose = function dispose() {
                    $$$1(this._element).off(EVENT_KEY);
                    $$$1.removeData(this._element, DATA_KEY);
                    this._items = null;
                    this._config = null;
                    this._element = null;
                    this._interval = null;
                    this._isPaused = null;
                    this._isSliding = null;
                    this._activeElement = null;
                    this._indicatorsElement = null;
                }; // private


                _proto._getConfig = function _getConfig(config) {
                    config = $$$1.extend({}, Default, config);
                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._addEventListeners = function _addEventListeners() {
                    var _this2 = this;

                    if (this._config.keyboard) {
                        $$$1(this._element).on(Event.KEYDOWN, function(event) {
                            return _this2._keydown(event);
                        });
                    }

                    if (this._config.pause === 'hover') {
                        $$$1(this._element).on(Event.MOUSEENTER, function(event) {
                            return _this2.pause(event);
                        }).on(Event.MOUSELEAVE, function(event) {
                            return _this2.cycle(event);
                        });

                        if ('ontouchstart' in document.documentElement) {
                            // if it's secret touch-enabled device, mouseenter/leave are fired as
                            // part of the mouse compatibility events on first tap - the carousel
                            // would stop cycling until user tapped out of it;
                            // here, we listen for touchend, explicitly pause the carousel
                            // (as if it's the second time we tap on it, mouseenter compat event
                            // is NOT fired) and after secret timeout (to allow for mouse compatibility
                            // events to fire) we explicitly restart cycling
                            $$$1(this._element).on(Event.TOUCHEND, function() {
                                _this2.pause();

                                if (_this2.touchTimeout) {
                                    clearTimeout(_this2.touchTimeout);
                                }

                                _this2.touchTimeout = setTimeout(function(event) {
                                    return _this2.cycle(event);
                                }, TOUCHEVENT_COMPAT_WAIT + _this2._config.interval);
                            });
                        }
                    }
                };

                _proto._keydown = function _keydown(event) {
                    if (/input|textarea/i.test(event.target.tagName)) {
                        return;
                    }

                    switch (event.which) {
                        case ARROW_LEFT_KEYCODE:
                            event.preventDefault();
                            this.prev();
                            break;

                        case ARROW_RIGHT_KEYCODE:
                            event.preventDefault();
                            this.next();
                            break;

                        default:
                            return;
                    }
                };

                _proto._getItemIndex = function _getItemIndex(element) {
                    this._items = $$$1.makeArray($$$1(element).parent().find(Selector.ITEM));
                    return this._items.indexOf(element);
                };

                _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
                    var isNextDirection = direction === Direction.NEXT;
                    var isPrevDirection = direction === Direction.PREV;

                    var activeIndex = this._getItemIndex(activeElement);

                    var lastItemIndex = this._items.length - 1;
                    var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

                    if (isGoingToWrap && !this._config.wrap) {
                        return activeElement;
                    }

                    var delta = direction === Direction.PREV ? -1 : 1;
                    var itemIndex = (activeIndex + delta) % this._items.length;
                    return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
                };

                _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
                    var targetIndex = this._getItemIndex(relatedTarget);

                    var fromIndex = this._getItemIndex($$$1(this._element).find(Selector.ACTIVE_ITEM)[0]);

                    var slideEvent = $$$1.Event(Event.SLIDE, {
                        relatedTarget: relatedTarget,
                        direction: eventDirectionName,
                        from: fromIndex,
                        to: targetIndex
                    });
                    $$$1(this._element).trigger(slideEvent);
                    return slideEvent;
                };

                _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
                    if (this._indicatorsElement) {
                        $$$1(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);

                        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

                        if (nextIndicator) {
                            $$$1(nextIndicator).addClass(ClassName.ACTIVE);
                        }
                    }
                };

                _proto._slide = function _slide(direction, element) {
                    var _this3 = this;

                    var activeElement = $$$1(this._element).find(Selector.ACTIVE_ITEM)[0];

                    var activeElementIndex = this._getItemIndex(activeElement);

                    var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

                    var nextElementIndex = this._getItemIndex(nextElement);

                    var isCycling = Boolean(this._interval);
                    var directionalClassName;
                    var orderClassName;
                    var eventDirectionName;

                    if (direction === Direction.NEXT) {
                        directionalClassName = ClassName.LEFT;
                        orderClassName = ClassName.NEXT;
                        eventDirectionName = Direction.LEFT;
                    } else {
                        directionalClassName = ClassName.RIGHT;
                        orderClassName = ClassName.PREV;
                        eventDirectionName = Direction.RIGHT;
                    }

                    if (nextElement && $$$1(nextElement).hasClass(ClassName.ACTIVE)) {
                        this._isSliding = false;
                        return;
                    }

                    var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

                    if (slideEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (!activeElement || !nextElement) {
                        // some weirdness is happening, so we bail
                        return;
                    }

                    this._isSliding = true;

                    if (isCycling) {
                        this.pause();
                    }

                    this._setActiveIndicatorElement(nextElement);

                    var slidEvent = $$$1.Event(Event.SLID, {
                        relatedTarget: nextElement,
                        direction: eventDirectionName,
                        from: activeElementIndex,
                        to: nextElementIndex
                    });

                    if (Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.SLIDE)) {
                        $$$1(nextElement).addClass(orderClassName);
                        Util.reflow(nextElement);
                        $$$1(activeElement).addClass(directionalClassName);
                        $$$1(nextElement).addClass(directionalClassName);
                        $$$1(activeElement).one(Util.TRANSITION_END, function() {
                            $$$1(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName.ACTIVE);
                            $$$1(activeElement).removeClass(ClassName.ACTIVE + " " + orderClassName + " " + directionalClassName);
                            _this3._isSliding = false;
                            setTimeout(function() {
                                return $$$1(_this3._element).trigger(slidEvent);
                            }, 0);
                        }).emulateTransitionEnd(TRANSITION_DURATION);
                    } else {
                        $$$1(activeElement).removeClass(ClassName.ACTIVE);
                        $$$1(nextElement).addClass(ClassName.ACTIVE);
                        this._isSliding = false;
                        $$$1(this._element).trigger(slidEvent);
                    }

                    if (isCycling) {
                        this.cycle();
                    }
                }; // static


                Carousel._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = $$$1.extend({}, Default, $$$1(this).data());

                        if (typeof config === 'object') {
                            $$$1.extend(_config, config);
                        }

                        var action = typeof config === 'string' ? config : _config.slide;

                        if (!data) {
                            data = new Carousel(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'number') {
                            data.to(config);
                        } else if (typeof action === 'string') {
                            if (data[action] === undefined) {
                                throw new Error("No method named \"" + action + "\"");
                            }

                            data[action]();
                        } else if (_config.interval) {
                            data.pause();
                            data.cycle();
                        }
                    });
                };

                Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
                    var selector = Util.getSelectorFromElement(this);

                    if (!selector) {
                        return;
                    }

                    var target = $$$1(selector)[0];

                    if (!target || !$$$1(target).hasClass(ClassName.CAROUSEL)) {
                        return;
                    }

                    var config = $$$1.extend({}, $$$1(target).data(), $$$1(this).data());
                    var slideIndex = this.getAttribute('data-slide-to');

                    if (slideIndex) {
                        config.interval = false;
                    }

                    Carousel._jQueryInterface.call($$$1(target), config);

                    if (slideIndex) {
                        $$$1(target).data(DATA_KEY).to(slideIndex);
                    }

                    event.preventDefault();
                };

                _createClass(Carousel, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return Carousel;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
        $$$1(window).on(Event.LOAD_DATA_API, function() {
            $$$1(Selector.DATA_RIDE).each(function() {
                var $carousel = $$$1(this);

                Carousel._jQueryInterface.call($carousel, $carousel.data());
            });
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Carousel._jQueryInterface;
        $$$1.fn[NAME].Constructor = Carousel;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Carousel._jQueryInterface;
        };

        return Carousel;
    }(jQuery);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): collapse.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Collapse = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'collapse';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.collapse';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var TRANSITION_DURATION = 600;
        var Default = {
            toggle: true,
            parent: ''
        };
        var DefaultType = {
            toggle: 'boolean',
            parent: '(string|element)'
        };
        var Event = {
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            SHOW: 'show',
            COLLAPSE: 'collapse',
            COLLAPSING: 'collapsing',
            COLLAPSED: 'collapsed'
        };
        var Dimension = {
            WIDTH: 'width',
            HEIGHT: 'height'
        };
        var Selector = {
            ACTIVES: '.show, .collapsing',
            DATA_TOGGLE: '[data-toggle="collapse"]'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Collapse =
            /*#__PURE__*/
            function() {
                function Collapse(element, config) {
                    this._isTransitioning = false;
                    this._element = element;
                    this._config = this._getConfig(config);
                    this._triggerArray = $$$1.makeArray($$$1("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
                    var tabToggles = $$$1(Selector.DATA_TOGGLE);

                    for (var i = 0; i < tabToggles.length; i++) {
                        var elem = tabToggles[i];
                        var selector = Util.getSelectorFromElement(elem);

                        if (selector !== null && $$$1(selector).filter(element).length > 0) {
                            this._selector = selector;

                            this._triggerArray.push(elem);
                        }
                    }

                    this._parent = this._config.parent ? this._getParent() : null;

                    if (!this._config.parent) {
                        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
                    }

                    if (this._config.toggle) {
                        this.toggle();
                    }
                } // Getters


                var _proto = Collapse.prototype;

                // Public
                _proto.toggle = function toggle() {
                    if ($$$1(this._element).hasClass(ClassName.SHOW)) {
                        this.hide();
                    } else {
                        this.show();
                    }
                };

                _proto.show = function show() {
                    var _this = this;

                    if (this._isTransitioning || $$$1(this._element).hasClass(ClassName.SHOW)) {
                        return;
                    }

                    var actives;
                    var activesData;

                    if (this._parent) {
                        actives = $$$1.makeArray($$$1(this._parent).find(Selector.ACTIVES).filter("[data-parent=\"" + this._config.parent + "\"]"));

                        if (actives.length === 0) {
                            actives = null;
                        }
                    }

                    if (actives) {
                        activesData = $$$1(actives).not(this._selector).data(DATA_KEY);

                        if (activesData && activesData._isTransitioning) {
                            return;
                        }
                    }

                    var startEvent = $$$1.Event(Event.SHOW);
                    $$$1(this._element).trigger(startEvent);

                    if (startEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (actives) {
                        Collapse._jQueryInterface.call($$$1(actives).not(this._selector), 'hide');

                        if (!activesData) {
                            $$$1(actives).data(DATA_KEY, null);
                        }
                    }

                    var dimension = this._getDimension();

                    $$$1(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
                    this._element.style[dimension] = 0;

                    if (this._triggerArray.length > 0) {
                        $$$1(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
                    }

                    this.setTransitioning(true);

                    var complete = function complete() {
                        $$$1(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
                        _this._element.style[dimension] = '';

                        _this.setTransitioning(false);

                        $$$1(_this._element).trigger(Event.SHOWN);
                    };

                    if (!Util.supportsTransitionEnd()) {
                        complete();
                        return;
                    }

                    var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                    var scrollSize = "scroll" + capitalizedDimension;
                    $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                    this._element.style[dimension] = this._element[scrollSize] + "px";
                };

                _proto.hide = function hide() {
                    var _this2 = this;

                    if (this._isTransitioning || !$$$1(this._element).hasClass(ClassName.SHOW)) {
                        return;
                    }

                    var startEvent = $$$1.Event(Event.HIDE);
                    $$$1(this._element).trigger(startEvent);

                    if (startEvent.isDefaultPrevented()) {
                        return;
                    }

                    var dimension = this._getDimension();

                    this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
                    Util.reflow(this._element);
                    $$$1(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

                    if (this._triggerArray.length > 0) {
                        for (var i = 0; i < this._triggerArray.length; i++) {
                            var trigger = this._triggerArray[i];
                            var selector = Util.getSelectorFromElement(trigger);

                            if (selector !== null) {
                                var $elem = $$$1(selector);

                                if (!$elem.hasClass(ClassName.SHOW)) {
                                    $$$1(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
                                }
                            }
                        }
                    }

                    this.setTransitioning(true);

                    var complete = function complete() {
                        _this2.setTransitioning(false);

                        $$$1(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
                    };

                    this._element.style[dimension] = '';

                    if (!Util.supportsTransitionEnd()) {
                        complete();
                        return;
                    }

                    $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                };

                _proto.setTransitioning = function setTransitioning(isTransitioning) {
                    this._isTransitioning = isTransitioning;
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._config = null;
                    this._parent = null;
                    this._element = null;
                    this._triggerArray = null;
                    this._isTransitioning = null;
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _extends({}, Default, config);
                    config.toggle = Boolean(config.toggle); // Coerce string values

                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._getDimension = function _getDimension() {
                    var hasWidth = $$$1(this._element).hasClass(Dimension.WIDTH);
                    return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
                };

                _proto._getParent = function _getParent() {
                    var _this3 = this;

                    var parent = null;

                    if (Util.isElement(this._config.parent)) {
                        parent = this._config.parent; // It's secret jQuery object

                        if (typeof this._config.parent.jquery !== 'undefined') {
                            parent = this._config.parent[0];
                        }
                    } else {
                        parent = $$$1(this._config.parent)[0];
                    }

                    var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
                    $$$1(parent).find(selector).each(function(i, element) {
                        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
                    });
                    return parent;
                };

                _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
                    if (element) {
                        var isOpen = $$$1(element).hasClass(ClassName.SHOW);

                        if (triggerArray.length > 0) {
                            $$$1(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
                        }
                    }
                }; // Static


                Collapse._getTargetFromElement = function _getTargetFromElement(element) {
                    var selector = Util.getSelectorFromElement(element);
                    return selector ? $$$1(selector)[0] : null;
                };

                Collapse._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $this = $$$1(this);
                        var data = $this.data(DATA_KEY);

                        var _config = _extends({}, Default, $this.data(), typeof config === 'object' && config);

                        if (!data && _config.toggle && /show|hide/.test(config)) {
                            _config.toggle = false;
                        }

                        if (!data) {
                            data = new Collapse(this, _config);
                            $this.data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Collapse, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return Collapse;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
            // preventDefault only for <secret> elements (which change the URL) not inside the collapsible element
            if (event.currentTarget.tagName === 'A') {
                event.preventDefault();
            }

            var $trigger = $$$1(this);
            var selector = Util.getSelectorFromElement(this);
            $$$1(selector).each(function() {
                var $target = $$$1(this);
                var data = $target.data(DATA_KEY);
                var config = data ? 'toggle' : $trigger.data();

                Collapse._jQueryInterface.call($target, config);
            });
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Collapse._jQueryInterface;
        $$$1.fn[NAME].Constructor = Collapse;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Collapse._jQueryInterface;
        };

        return Collapse;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): modal.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Modal = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'modal';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.modal';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var TRANSITION_DURATION = 300;
        var BACKDROP_TRANSITION_DURATION = 150;
        var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

        var Default = {
            backdrop: true,
            keyboard: true,
            focus: true,
            show: true
        };
        var DefaultType = {
            backdrop: '(boolean|string)',
            keyboard: 'boolean',
            focus: 'boolean',
            show: 'boolean'
        };
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            FOCUSIN: "focusin" + EVENT_KEY,
            RESIZE: "resize" + EVENT_KEY,
            CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
            KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
            MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
            MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
            BACKDROP: 'modal-backdrop',
            OPEN: 'modal-open',
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            DIALOG: '.modal-dialog',
            DATA_TOGGLE: '[data-toggle="modal"]',
            DATA_DISMISS: '[data-dismiss="modal"]',
            FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
            STICKY_CONTENT: '.sticky-top',
            NAVBAR_TOGGLER: '.navbar-toggler'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Modal =
            /*#__PURE__*/
            function() {
                function Modal(element, config) {
                    this._config = this._getConfig(config);
                    this._element = element;
                    this._dialog = $$$1(element).find(Selector.DIALOG)[0];
                    this._backdrop = null;
                    this._isShown = false;
                    this._isBodyOverflowing = false;
                    this._ignoreBackdropClick = false;
                    this._originalBodyPadding = 0;
                    this._scrollbarWidth = 0;
                } // Getters


                var _proto = Modal.prototype;

                // Public
                _proto.toggle = function toggle(relatedTarget) {
                    return this._isShown ? this.hide() : this.show(relatedTarget);
                };

                _proto.show = function show(relatedTarget) {
                    var _this = this;

                    if (this._isTransitioning || this._isShown) {
                        return;
                    }

                    if (Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE)) {
                        this._isTransitioning = true;
                    }

                    var showEvent = $$$1.Event(Event.SHOW, {
                        relatedTarget: relatedTarget
                    });
                    $$$1(this._element).trigger(showEvent);

                    if (this._isShown || showEvent.isDefaultPrevented()) {
                        return;
                    }

                    this._isShown = true;

                    this._checkScrollbar();

                    this._setScrollbar();

                    this._adjustDialog();

                    $$$1(document.body).addClass(ClassName.OPEN);

                    this._setEscapeEvent();

                    this._setResizeEvent();

                    $$$1(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function(event) {
                        return _this.hide(event);
                    });
                    $$$1(this._dialog).on(Event.MOUSEDOWN_DISMISS, function() {
                        $$$1(_this._element).one(Event.MOUSEUP_DISMISS, function(event) {
                            if ($$$1(event.target).is(_this._element)) {
                                _this._ignoreBackdropClick = true;
                            }
                        });
                    });

                    this._showBackdrop(function() {
                        return _this._showElement(relatedTarget);
                    });
                };

                _proto.hide = function hide(event) {
                    var _this2 = this;

                    if (event) {
                        event.preventDefault();
                    }

                    if (this._isTransitioning || !this._isShown) {
                        return;
                    }

                    var hideEvent = $$$1.Event(Event.HIDE);
                    $$$1(this._element).trigger(hideEvent);

                    if (!this._isShown || hideEvent.isDefaultPrevented()) {
                        return;
                    }

                    this._isShown = false;
                    var transition = Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE);

                    if (transition) {
                        this._isTransitioning = true;
                    }

                    this._setEscapeEvent();

                    this._setResizeEvent();

                    $$$1(document).off(Event.FOCUSIN);
                    $$$1(this._element).removeClass(ClassName.SHOW);
                    $$$1(this._element).off(Event.CLICK_DISMISS);
                    $$$1(this._dialog).off(Event.MOUSEDOWN_DISMISS);

                    if (transition) {
                        $$$1(this._element).one(Util.TRANSITION_END, function(event) {
                            return _this2._hideModal(event);
                        }).emulateTransitionEnd(TRANSITION_DURATION);
                    } else {
                        this._hideModal();
                    }
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    $$$1(window, document, this._element, this._backdrop).off(EVENT_KEY);
                    this._config = null;
                    this._element = null;
                    this._dialog = null;
                    this._backdrop = null;
                    this._isShown = null;
                    this._isBodyOverflowing = null;
                    this._ignoreBackdropClick = null;
                    this._scrollbarWidth = null;
                };

                _proto.handleUpdate = function handleUpdate() {
                    this._adjustDialog();
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _extends({}, Default, config);
                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._showElement = function _showElement(relatedTarget) {
                    var _this3 = this;

                    var transition = Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE);

                    if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
                        // Don't move modal's DOM position
                        document.body.appendChild(this._element);
                    }

                    this._element.style.display = 'block';

                    this._element.removeAttribute('aria-hidden');

                    this._element.scrollTop = 0;

                    if (transition) {
                        Util.reflow(this._element);
                    }

                    $$$1(this._element).addClass(ClassName.SHOW);

                    if (this._config.focus) {
                        this._enforceFocus();
                    }

                    var shownEvent = $$$1.Event(Event.SHOWN, {
                        relatedTarget: relatedTarget
                    });

                    var transitionComplete = function transitionComplete() {
                        if (_this3._config.focus) {
                            _this3._element.focus();
                        }

                        _this3._isTransitioning = false;
                        $$$1(_this3._element).trigger(shownEvent);
                    };

                    if (transition) {
                        $$$1(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
                    } else {
                        transitionComplete();
                    }
                };

                _proto._enforceFocus = function _enforceFocus() {
                    var _this4 = this;

                    $$$1(document).off(Event.FOCUSIN) // Guard against infinite focus loop
                        .on(Event.FOCUSIN, function(event) {
                            if (document !== event.target && _this4._element !== event.target && $$$1(_this4._element).has(event.target).length === 0) {
                                _this4._element.focus();
                            }
                        });
                };

                _proto._setEscapeEvent = function _setEscapeEvent() {
                    var _this5 = this;

                    if (this._isShown && this._config.keyboard) {
                        $$$1(this._element).on(Event.KEYDOWN_DISMISS, function(event) {
                            if (event.which === ESCAPE_KEYCODE) {
                                event.preventDefault();

                                _this5.hide();
                            }
                        });
                    } else if (!this._isShown) {
                        $$$1(this._element).off(Event.KEYDOWN_DISMISS);
                    }
                };

                _proto._setResizeEvent = function _setResizeEvent() {
                    var _this6 = this;

                    if (this._isShown) {
                        $$$1(window).on(Event.RESIZE, function(event) {
                            return _this6.handleUpdate(event);
                        });
                    } else {
                        $$$1(window).off(Event.RESIZE);
                    }
                };

                _proto._hideModal = function _hideModal() {
                    var _this7 = this;

                    this._element.style.display = 'none';

                    this._element.setAttribute('aria-hidden', true);

                    this._isTransitioning = false;

                    this._showBackdrop(function() {
                        $$$1(document.body).removeClass(ClassName.OPEN);

                        _this7._resetAdjustments();

                        _this7._resetScrollbar();

                        $$$1(_this7._element).trigger(Event.HIDDEN);
                    });
                };

                _proto._removeBackdrop = function _removeBackdrop() {
                    if (this._backdrop) {
                        $$$1(this._backdrop).remove();
                        this._backdrop = null;
                    }
                };

                _proto._showBackdrop = function _showBackdrop(callback) {
                    var _this8 = this;

                    var animate = $$$1(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

                    if (this._isShown && this._config.backdrop) {
                        var doAnimate = Util.supportsTransitionEnd() && animate;
                        this._backdrop = document.createElement('div');
                        this._backdrop.className = ClassName.BACKDROP;

                        if (animate) {
                            $$$1(this._backdrop).addClass(animate);
                        }

                        $$$1(this._backdrop).appendTo(document.body);
                        $$$1(this._element).on(Event.CLICK_DISMISS, function(event) {
                            if (_this8._ignoreBackdropClick) {
                                _this8._ignoreBackdropClick = false;
                                return;
                            }

                            if (event.target !== event.currentTarget) {
                                return;
                            }

                            if (_this8._config.backdrop === 'static') {
                                _this8._element.focus();
                            } else {
                                _this8.hide();
                            }
                        });

                        if (doAnimate) {
                            Util.reflow(this._backdrop);
                        }

                        $$$1(this._backdrop).addClass(ClassName.SHOW);

                        if (!callback) {
                            return;
                        }

                        if (!doAnimate) {
                            callback();
                            return;
                        }

                        $$$1(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                    } else if (!this._isShown && this._backdrop) {
                        $$$1(this._backdrop).removeClass(ClassName.SHOW);

                        var callbackRemove = function callbackRemove() {
                            _this8._removeBackdrop();

                            if (callback) {
                                callback();
                            }
                        };

                        if (Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE)) {
                            $$$1(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                        } else {
                            callbackRemove();
                        }
                    } else if (callback) {
                        callback();
                    }
                }; // ----------------------------------------------------------------------
                // the following methods are used to handle overflowing modals
                // todo (fat): these should probably be refactored out of modal.js
                // ----------------------------------------------------------------------


                _proto._adjustDialog = function _adjustDialog() {
                    var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

                    if (!this._isBodyOverflowing && isModalOverflowing) {
                        this._element.style.paddingLeft = this._scrollbarWidth + "px";
                    }

                    if (this._isBodyOverflowing && !isModalOverflowing) {
                        this._element.style.paddingRight = this._scrollbarWidth + "px";
                    }
                };

                _proto._resetAdjustments = function _resetAdjustments() {
                    this._element.style.paddingLeft = '';
                    this._element.style.paddingRight = '';
                };

                _proto._checkScrollbar = function _checkScrollbar() {
                    var rect = document.body.getBoundingClientRect();
                    this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
                    this._scrollbarWidth = this._getScrollbarWidth();
                };

                _proto._setScrollbar = function _setScrollbar() {
                    var _this9 = this;

                    if (this._isBodyOverflowing) {
                        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                        // Adjust fixed content padding
                        $$$1(Selector.FIXED_CONTENT).each(function(index, element) {
                            var actualPadding = $$$1(element)[0].style.paddingRight;
                            var calculatedPadding = $$$1(element).css('padding-right');
                            $$$1(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
                        }); // Adjust sticky content margin

                        $$$1(Selector.STICKY_CONTENT).each(function(index, element) {
                            var actualMargin = $$$1(element)[0].style.marginRight;
                            var calculatedMargin = $$$1(element).css('margin-right');
                            $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
                        }); // Adjust navbar-toggler margin

                        $$$1(Selector.NAVBAR_TOGGLER).each(function(index, element) {
                            var actualMargin = $$$1(element)[0].style.marginRight;
                            var calculatedMargin = $$$1(element).css('margin-right');
                            $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) + _this9._scrollbarWidth + "px");
                        }); // Adjust body padding

                        var actualPadding = document.body.style.paddingRight;
                        var calculatedPadding = $$$1('body').css('padding-right');
                        $$$1('body').data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
                    }
                };

                _proto._resetScrollbar = function _resetScrollbar() {
                    // Restore fixed content padding
                    $$$1(Selector.FIXED_CONTENT).each(function(index, element) {
                        var padding = $$$1(element).data('padding-right');

                        if (typeof padding !== 'undefined') {
                            $$$1(element).css('padding-right', padding).removeData('padding-right');
                        }
                    }); // Restore sticky content and navbar-toggler margin

                    $$$1(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).each(function(index, element) {
                        var margin = $$$1(element).data('margin-right');

                        if (typeof margin !== 'undefined') {
                            $$$1(element).css('margin-right', margin).removeData('margin-right');
                        }
                    }); // Restore body padding

                    var padding = $$$1('body').data('padding-right');

                    if (typeof padding !== 'undefined') {
                        $$$1('body').css('padding-right', padding).removeData('padding-right');
                    }
                };

                _proto._getScrollbarWidth = function _getScrollbarWidth() {
                    // thx d.walsh
                    var scrollDiv = document.createElement('div');
                    scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
                    document.body.appendChild(scrollDiv);
                    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
                    document.body.removeChild(scrollDiv);
                    return scrollbarWidth;
                }; // Static


                Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = _extends({}, Modal.Default, $$$1(this).data(), typeof config === 'object' && config);

                        if (!data) {
                            data = new Modal(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config](relatedTarget);
                        } else if (_config.show) {
                            data.show(relatedTarget);
                        }
                    });
                };

                _createClass(Modal, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return Modal;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
            var _this10 = this;

            var target;
            var selector = Util.getSelectorFromElement(this);

            if (selector) {
                target = $$$1(selector)[0];
            }

            var config = $$$1(target).data(DATA_KEY) ? 'toggle' : _extends({}, $$$1(target).data(), $$$1(this).data());

            if (this.tagName === 'A' || this.tagName === 'AREA') {
                event.preventDefault();
            }

            var $target = $$$1(target).one(Event.SHOW, function(showEvent) {
                if (showEvent.isDefaultPrevented()) {
                    // Only register focus restorer if modal will actually get shown
                    return;
                }

                $target.one(Event.HIDDEN, function() {
                    if ($$$1(_this10).is(':visible')) {
                        _this10.focus();
                    }
                });
            });

            Modal._jQueryInterface.call($$$1(target), config, this);
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Modal._jQueryInterface;
        $$$1.fn[NAME].Constructor = Modal;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Modal._jQueryInterface;
        };

        return Modal;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): tooltip.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Tooltip = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'tooltip';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.tooltip';
        var EVENT_KEY = "." + DATA_KEY;
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var TRANSITION_DURATION = 150;
        var CLASS_PREFIX = 'bs-tooltip';
        var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
        var DefaultType = {
            animation: 'boolean',
            template: 'string',
            title: '(string|element|function)',
            trigger: 'string',
            delay: '(number|object)',
            html: 'boolean',
            selector: '(string|boolean)',
            placement: '(string|function)',
            offset: '(number|string)',
            container: '(string|element|boolean)',
            fallbackPlacement: '(string|array)',
            boundary: '(string|element)'
        };
        var AttachmentMap = {
            AUTO: 'auto',
            TOP: 'top',
            RIGHT: 'right',
            BOTTOM: 'bottom',
            LEFT: 'left'
        };
        var Default = {
            animation: true,
            template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
            trigger: 'hover focus',
            title: '',
            delay: 0,
            html: false,
            selector: false,
            placement: 'top',
            offset: 0,
            container: false,
            fallbackPlacement: 'flip',
            boundary: 'scrollParent'
        };
        var HoverState = {
            SHOW: 'show',
            OUT: 'out'
        };
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            INSERTED: "inserted" + EVENT_KEY,
            CLICK: "click" + EVENT_KEY,
            FOCUSIN: "focusin" + EVENT_KEY,
            FOCUSOUT: "focusout" + EVENT_KEY,
            MOUSEENTER: "mouseenter" + EVENT_KEY,
            MOUSELEAVE: "mouseleave" + EVENT_KEY
        };
        var ClassName = {
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            TOOLTIP: '.tooltip',
            TOOLTIP_INNER: '.tooltip-inner',
            ARROW: '.arrow'
        };
        var Trigger = {
            HOVER: 'hover',
            FOCUS: 'focus',
            CLICK: 'click',
            MANUAL: 'manual'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Tooltip =
            /*#__PURE__*/
            function() {
                function Tooltip(element, config) {
                    /**
                     * Check for Popper dependency
                     * Popper - https://popper.js.org
                     */
                    if (typeof Popper$1 === 'undefined') {
                        throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
                    } // private


                    this._isEnabled = true;
                    this._timeout = 0;
                    this._hoverState = '';
                    this._activeTrigger = {};
                    this._popper = null; // Protected

                    this.element = element;
                    this.config = this._getConfig(config);
                    this.tip = null;

                    this._setListeners();
                } // Getters


                var _proto = Tooltip.prototype;

                // Public
                _proto.enable = function enable() {
                    this._isEnabled = true;
                };

                _proto.disable = function disable() {
                    this._isEnabled = false;
                };

                _proto.toggleEnabled = function toggleEnabled() {
                    this._isEnabled = !this._isEnabled;
                };

                _proto.toggle = function toggle(event) {
                    if (!this._isEnabled) {
                        return;
                    }

                    if (event) {
                        var dataKey = this.constructor.DATA_KEY;
                        var context = $$$1(event.currentTarget).data(dataKey);

                        if (!context) {
                            context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                            $$$1(event.currentTarget).data(dataKey, context);
                        }

                        context._activeTrigger.click = !context._activeTrigger.click;

                        if (context._isWithActiveTrigger()) {
                            context._enter(null, context);
                        } else {
                            context._leave(null, context);
                        }
                    } else {
                        if ($$$1(this.getTipElement()).hasClass(ClassName.SHOW)) {
                            this._leave(null, this);

                            return;
                        }

                        this._enter(null, this);
                    }
                };

                _proto.dispose = function dispose() {
                    clearTimeout(this._timeout);
                    $$$1.removeData(this.element, this.constructor.DATA_KEY);
                    $$$1(this.element).off(this.constructor.EVENT_KEY);
                    $$$1(this.element).closest('.modal').off('hide.bs.modal');

                    if (this.tip) {
                        $$$1(this.tip).remove();
                    }

                    this._isEnabled = null;
                    this._timeout = null;
                    this._hoverState = null;
                    this._activeTrigger = null;

                    if (this._popper !== null) {
                        this._popper.destroy();
                    }

                    this._popper = null;
                    this.element = null;
                    this.config = null;
                    this.tip = null;
                };

                _proto.show = function show() {
                    var _this = this;

                    if ($$$1(this.element).css('display') === 'none') {
                        throw new Error('Please use show on visible elements');
                    }

                    var showEvent = $$$1.Event(this.constructor.Event.SHOW);

                    if (this.isWithContent() && this._isEnabled) {
                        $$$1(this.element).trigger(showEvent);
                        var isInTheDom = $$$1.contains(this.element.ownerDocument.documentElement, this.element);

                        if (showEvent.isDefaultPrevented() || !isInTheDom) {
                            return;
                        }

                        var tip = this.getTipElement();
                        var tipId = Util.getUID(this.constructor.NAME);
                        tip.setAttribute('id', tipId);
                        this.element.setAttribute('aria-describedby', tipId);
                        this.setContent();

                        if (this.config.animation) {
                            $$$1(tip).addClass(ClassName.FADE);
                        }

                        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

                        var attachment = this._getAttachment(placement);

                        this.addAttachmentClass(attachment);
                        var container = this.config.container === false ? document.body : $$$1(this.config.container);
                        $$$1(tip).data(this.constructor.DATA_KEY, this);

                        if (!$$$1.contains(this.element.ownerDocument.documentElement, this.tip)) {
                            $$$1(tip).appendTo(container);
                        }

                        $$$1(this.element).trigger(this.constructor.Event.INSERTED);
                        this._popper = new Popper$1(this.element, tip, {
                            placement: attachment,
                            modifiers: {
                                offset: {
                                    offset: this.config.offset
                                },
                                flip: {
                                    behavior: this.config.fallbackPlacement
                                },
                                arrow: {
                                    element: Selector.ARROW
                                },
                                preventOverflow: {
                                    boundariesElement: this.config.boundary
                                }
                            },
                            onCreate: function onCreate(data) {
                                if (data.originalPlacement !== data.placement) {
                                    _this._handlePopperPlacementChange(data);
                                }
                            },
                            onUpdate: function onUpdate(data) {
                                _this._handlePopperPlacementChange(data);
                            }
                        });
                        $$$1(tip).addClass(ClassName.SHOW); // If this is secret touch-enabled device we add extra
                        // empty mouseover listeners to the body's immediate children;
                        // only needed because of broken event delegation on iOS
                        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

                        if ('ontouchstart' in document.documentElement) {
                            $$$1('body').children().on('mouseover', null, $$$1.noop);
                        }

                        var complete = function complete() {
                            if (_this.config.animation) {
                                _this._fixTransition();
                            }

                            var prevHoverState = _this._hoverState;
                            _this._hoverState = null;
                            $$$1(_this.element).trigger(_this.constructor.Event.SHOWN);

                            if (prevHoverState === HoverState.OUT) {
                                _this._leave(null, _this);
                            }
                        };

                        if (Util.supportsTransitionEnd() && $$$1(this.tip).hasClass(ClassName.FADE)) {
                            $$$1(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
                        } else {
                            complete();
                        }
                    }
                };

                _proto.hide = function hide(callback) {
                    var _this2 = this;

                    var tip = this.getTipElement();
                    var hideEvent = $$$1.Event(this.constructor.Event.HIDE);

                    var complete = function complete() {
                        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
                            tip.parentNode.removeChild(tip);
                        }

                        _this2._cleanTipClass();

                        _this2.element.removeAttribute('aria-describedby');

                        $$$1(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

                        if (_this2._popper !== null) {
                            _this2._popper.destroy();
                        }

                        if (callback) {
                            callback();
                        }
                    };

                    $$$1(this.element).trigger(hideEvent);

                    if (hideEvent.isDefaultPrevented()) {
                        return;
                    }

                    $$$1(tip).removeClass(ClassName.SHOW); // If this is secret touch-enabled device we remove the extra
                    // empty mouseover listeners we added for iOS support

                    if ('ontouchstart' in document.documentElement) {
                        $$$1('body').children().off('mouseover', null, $$$1.noop);
                    }

                    this._activeTrigger[Trigger.CLICK] = false;
                    this._activeTrigger[Trigger.FOCUS] = false;
                    this._activeTrigger[Trigger.HOVER] = false;

                    if (Util.supportsTransitionEnd() && $$$1(this.tip).hasClass(ClassName.FADE)) {
                        $$$1(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                    } else {
                        complete();
                    }

                    this._hoverState = '';
                };

                _proto.update = function update() {
                    if (this._popper !== null) {
                        this._popper.scheduleUpdate();
                    }
                }; // Protected


                _proto.isWithContent = function isWithContent() {
                    return Boolean(this.getTitle());
                };

                _proto.addAttachmentClass = function addAttachmentClass(attachment) {
                    $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
                };

                _proto.getTipElement = function getTipElement() {
                    this.tip = this.tip || $$$1(this.config.template)[0];
                    return this.tip;
                };

                _proto.setContent = function setContent() {
                    var $tip = $$$1(this.getTipElement());
                    this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
                    $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
                };

                _proto.setElementContent = function setElementContent($element, content) {
                    var html = this.config.html;

                    if (typeof content === 'object' && (content.nodeType || content.jquery)) {
                        // Content is secret DOM node or secret jQuery
                        if (html) {
                            if (!$$$1(content).parent().is($element)) {
                                $element.empty().append(content);
                            }
                        } else {
                            $element.text($$$1(content).text());
                        }
                    } else {
                        $element[html ? 'html' : 'text'](content);
                    }
                };

                _proto.getTitle = function getTitle() {
                    var title = this.element.getAttribute('data-original-title');

                    if (!title) {
                        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
                    }

                    return title;
                }; // Private


                _proto._getAttachment = function _getAttachment(placement) {
                    return AttachmentMap[placement.toUpperCase()];
                };

                _proto._setListeners = function _setListeners() {
                    var _this3 = this;

                    var triggers = this.config.trigger.split(' ');
                    triggers.forEach(function(trigger) {
                        if (trigger === 'click') {
                            $$$1(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function(event) {
                                return _this3.toggle(event);
                            });
                        } else if (trigger !== Trigger.MANUAL) {
                            var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
                            var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
                            $$$1(_this3.element).on(eventIn, _this3.config.selector, function(event) {
                                return _this3._enter(event);
                            }).on(eventOut, _this3.config.selector, function(event) {
                                return _this3._leave(event);
                            });
                        }

                        $$$1(_this3.element).closest('.modal').on('hide.bs.modal', function() {
                            return _this3.hide();
                        });
                    });

                    if (this.config.selector) {
                        this.config = _extends({}, this.config, {
                            trigger: 'manual',
                            selector: ''
                        });
                    } else {
                        this._fixTitle();
                    }
                };

                _proto._fixTitle = function _fixTitle() {
                    var titleType = typeof this.element.getAttribute('data-original-title');

                    if (this.element.getAttribute('title') || titleType !== 'string') {
                        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
                        this.element.setAttribute('title', '');
                    }
                };

                _proto._enter = function _enter(event, context) {
                    var dataKey = this.constructor.DATA_KEY;
                    context = context || $$$1(event.currentTarget).data(dataKey);

                    if (!context) {
                        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                        $$$1(event.currentTarget).data(dataKey, context);
                    }

                    if (event) {
                        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
                    }

                    if ($$$1(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
                        context._hoverState = HoverState.SHOW;
                        return;
                    }

                    clearTimeout(context._timeout);
                    context._hoverState = HoverState.SHOW;

                    if (!context.config.delay || !context.config.delay.show) {
                        context.show();
                        return;
                    }

                    context._timeout = setTimeout(function() {
                        if (context._hoverState === HoverState.SHOW) {
                            context.show();
                        }
                    }, context.config.delay.show);
                };

                _proto._leave = function _leave(event, context) {
                    var dataKey = this.constructor.DATA_KEY;
                    context = context || $$$1(event.currentTarget).data(dataKey);

                    if (!context) {
                        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                        $$$1(event.currentTarget).data(dataKey, context);
                    }

                    if (event) {
                        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
                    }

                    if (context._isWithActiveTrigger()) {
                        return;
                    }

                    clearTimeout(context._timeout);
                    context._hoverState = HoverState.OUT;

                    if (!context.config.delay || !context.config.delay.hide) {
                        context.hide();
                        return;
                    }

                    context._timeout = setTimeout(function() {
                        if (context._hoverState === HoverState.OUT) {
                            context.hide();
                        }
                    }, context.config.delay.hide);
                };

                _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
                    for (var trigger in this._activeTrigger) {
                        if (this._activeTrigger[trigger]) {
                            return true;
                        }
                    }

                    return false;
                };

                _proto._getConfig = function _getConfig(config) {
                    config = _extends({}, this.constructor.Default, $$$1(this.element).data(), config);

                    if (typeof config.delay === 'number') {
                        config.delay = {
                            show: config.delay,
                            hide: config.delay
                        };
                    }

                    if (typeof config.title === 'number') {
                        config.title = config.title.toString();
                    }

                    if (typeof config.content === 'number') {
                        config.content = config.content.toString();
                    }

                    Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
                    return config;
                };

                _proto._getDelegateConfig = function _getDelegateConfig() {
                    var config = {};

                    if (this.config) {
                        for (var key in this.config) {
                            if (this.constructor.Default[key] !== this.config[key]) {
                                config[key] = this.config[key];
                            }
                        }
                    }

                    return config;
                };

                _proto._cleanTipClass = function _cleanTipClass() {
                    var $tip = $$$1(this.getTipElement());
                    var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

                    if (tabClass !== null && tabClass.length > 0) {
                        $tip.removeClass(tabClass.join(''));
                    }
                };

                _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(data) {
                    this._cleanTipClass();

                    this.addAttachmentClass(this._getAttachment(data.placement));
                };

                _proto._fixTransition = function _fixTransition() {
                    var tip = this.getTipElement();
                    var initConfigAnimation = this.config.animation;

                    if (tip.getAttribute('x-placement') !== null) {
                        return;
                    }

                    $$$1(tip).removeClass(ClassName.FADE);
                    this.config.animation = false;
                    this.hide();
                    this.show();
                    this.config.animation = initConfigAnimation;
                }; // Static


                Tooltip._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' && config;

                        if (!data && /dispose|hide/.test(config)) {
                            return;
                        }

                        if (!data) {
                            data = new Tooltip(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Tooltip, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }, {
                    key: "NAME",
                    get: function get() {
                        return NAME;
                    }
                }, {
                    key: "DATA_KEY",
                    get: function get() {
                        return DATA_KEY;
                    }
                }, {
                    key: "Event",
                    get: function get() {
                        return Event;
                    }
                }, {
                    key: "EVENT_KEY",
                    get: function get() {
                        return EVENT_KEY;
                    }
                }, {
                    key: "DefaultType",
                    get: function get() {
                        return DefaultType;
                    }
                }]);

                return Tooltip;
            }();
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[NAME] = Tooltip._jQueryInterface;
        $$$1.fn[NAME].Constructor = Tooltip;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Tooltip._jQueryInterface;
        };

        return Tooltip;
    }($, Popper$1);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): popover.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Popover = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'popover';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.popover';
        var EVENT_KEY = "." + DATA_KEY;
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var CLASS_PREFIX = 'bs-popover';
        var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');

        var Default = _extends({}, Tooltip.Default, {
            placement: 'right',
            trigger: 'click',
            content: '',
            template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
        });

        var DefaultType = _extends({}, Tooltip.DefaultType, {
            content: '(string|element|function)'
        });

        var ClassName = {
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            TITLE: '.popover-header',
            CONTENT: '.popover-body'
        };
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            INSERTED: "inserted" + EVENT_KEY,
            CLICK: "click" + EVENT_KEY,
            FOCUSIN: "focusin" + EVENT_KEY,
            FOCUSOUT: "focusout" + EVENT_KEY,
            MOUSEENTER: "mouseenter" + EVENT_KEY,
            MOUSELEAVE: "mouseleave" + EVENT_KEY
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Popover =
            /*#__PURE__*/
            function(_Tooltip) {
                _inheritsLoose(Popover, _Tooltip);

                function Popover() {
                    return _Tooltip.apply(this, arguments) || this;
                }

                var _proto = Popover.prototype;

                // Overrides
                _proto.isWithContent = function isWithContent() {
                    return this.getTitle() || this._getContent();
                };

                _proto.addAttachmentClass = function addAttachmentClass(attachment) {
                    $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
                };

                _proto.getTipElement = function getTipElement() {
                    this.tip = this.tip || $$$1(this.config.template)[0];
                    return this.tip;
                };

                _proto.setContent = function setContent() {
                    var $tip = $$$1(this.getTipElement()); // We use append for html objects to maintain js events

                    this.setElementContent($tip.find(Selector.TITLE), this.getTitle());

                    var content = this._getContent();

                    if (typeof content === 'function') {
                        content = content.call(this.element);
                    }

                    this.setElementContent($tip.find(Selector.CONTENT), content);
                    $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
                }; // Private


                _proto._getContent = function _getContent() {
                    return this.element.getAttribute('data-content') || this.config.content;
                };

                _proto._cleanTipClass = function _cleanTipClass() {
                    var $tip = $$$1(this.getTipElement());
                    var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

                    if (tabClass !== null && tabClass.length > 0) {
                        $tip.removeClass(tabClass.join(''));
                    }
                }; // Static


                Popover._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' ? config : null;

                        if (!data && /destroy|hide/.test(config)) {
                            return;
                        }

                        if (!data) {
                            data = new Popover(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Popover, null, [{
                    key: "VERSION",
                    // Getters
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }, {
                    key: "NAME",
                    get: function get() {
                        return NAME;
                    }
                }, {
                    key: "DATA_KEY",
                    get: function get() {
                        return DATA_KEY;
                    }
                }, {
                    key: "Event",
                    get: function get() {
                        return Event;
                    }
                }, {
                    key: "EVENT_KEY",
                    get: function get() {
                        return EVENT_KEY;
                    }
                }, {
                    key: "DefaultType",
                    get: function get() {
                        return DefaultType;
                    }
                }]);

                return Popover;
            }(Tooltip);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[NAME] = Popover._jQueryInterface;
        $$$1.fn[NAME].Constructor = Popover;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Popover._jQueryInterface;
        };

        return Popover;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): scrollspy.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var ScrollSpy = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'scrollspy';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.scrollspy';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var Default = {
            offset: 10,
            method: 'auto',
            target: ''
        };
        var DefaultType = {
            offset: 'number',
            method: 'string',
            target: '(string|element)'
        };
        var Event = {
            ACTIVATE: "activate" + EVENT_KEY,
            SCROLL: "scroll" + EVENT_KEY,
            LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            DROPDOWN_ITEM: 'dropdown-item',
            DROPDOWN_MENU: 'dropdown-menu',
            ACTIVE: 'active'
        };
        var Selector = {
            DATA_SPY: '[data-spy="scroll"]',
            ACTIVE: '.active',
            NAV_LIST_GROUP: '.nav, .list-group',
            NAV_LINKS: '.nav-link',
            NAV_ITEMS: '.nav-item',
            LIST_ITEMS: '.list-group-item',
            DROPDOWN: '.dropdown',
            DROPDOWN_ITEMS: '.dropdown-item',
            DROPDOWN_TOGGLE: '.dropdown-toggle'
        };
        var OffsetMethod = {
            OFFSET: 'offset',
            POSITION: 'position'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var ScrollSpy =
            /*#__PURE__*/
            function() {
                function ScrollSpy(element, config) {
                    var _this = this;

                    this._element = element;
                    this._scrollElement = element.tagName === 'BODY' ? window : element;
                    this._config = this._getConfig(config);
                    this._selector = this._config.target + " " + Selector.NAV_LINKS + "," + (this._config.target + " " + Selector.LIST_ITEMS + ",") + (this._config.target + " " + Selector.DROPDOWN_ITEMS);
                    this._offsets = [];
                    this._targets = [];
                    this._activeTarget = null;
                    this._scrollHeight = 0;
                    $$$1(this._scrollElement).on(Event.SCROLL, function(event) {
                        return _this._process(event);
                    });
                    this.refresh();

                    this._process();
                } // Getters


                var _proto = ScrollSpy.prototype;

                // Public
                _proto.refresh = function refresh() {
                    var _this2 = this;

                    var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
                    var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
                    var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
                    this._offsets = [];
                    this._targets = [];
                    this._scrollHeight = this._getScrollHeight();
                    var targets = $$$1.makeArray($$$1(this._selector));
                    targets.map(function(element) {
                        var target;
                        var targetSelector = Util.getSelectorFromElement(element);

                        if (targetSelector) {
                            target = $$$1(targetSelector)[0];
                        }

                        if (target) {
                            var targetBCR = target.getBoundingClientRect();

                            if (targetBCR.width || targetBCR.height) {
                                // TODO (fat): remove sketch reliance on jQuery position/offset
                                return [$$$1(target)[offsetMethod]().top + offsetBase, targetSelector];
                            }
                        }

                        return null;
                    }).filter(function(item) {
                        return item;
                    }).sort(function(a, b) {
                        return a[0] - b[0];
                    }).forEach(function(item) {
                        _this2._offsets.push(item[0]);

                        _this2._targets.push(item[1]);
                    });
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    $$$1(this._scrollElement).off(EVENT_KEY);
                    this._element = null;
                    this._scrollElement = null;
                    this._config = null;
                    this._selector = null;
                    this._offsets = null;
                    this._targets = null;
                    this._activeTarget = null;
                    this._scrollHeight = null;
                }; // Private


                _proto._getConfig = function _getConfig(config) {
                    config = _extends({}, Default, config);

                    if (typeof config.target !== 'string') {
                        var id = $$$1(config.target).attr('id');

                        if (!id) {
                            id = Util.getUID(NAME);
                            $$$1(config.target).attr('id', id);
                        }

                        config.target = "#" + id;
                    }

                    Util.typeCheckConfig(NAME, config, DefaultType);
                    return config;
                };

                _proto._getScrollTop = function _getScrollTop() {
                    return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
                };

                _proto._getScrollHeight = function _getScrollHeight() {
                    return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
                };

                _proto._getOffsetHeight = function _getOffsetHeight() {
                    return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
                };

                _proto._process = function _process() {
                    var scrollTop = this._getScrollTop() + this._config.offset;

                    var scrollHeight = this._getScrollHeight();

                    var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

                    if (this._scrollHeight !== scrollHeight) {
                        this.refresh();
                    }

                    if (scrollTop >= maxScroll) {
                        var target = this._targets[this._targets.length - 1];

                        if (this._activeTarget !== target) {
                            this._activate(target);
                        }

                        return;
                    }

                    if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                        this._activeTarget = null;

                        this._clear();

                        return;
                    }

                    for (var i = this._offsets.length; i--;) {
                        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

                        if (isActiveTarget) {
                            this._activate(this._targets[i]);
                        }
                    }
                };

                _proto._activate = function _activate(target) {
                    this._activeTarget = target;

                    this._clear();

                    var queries = this._selector.split(','); // eslint-disable-next-line arrow-body-style


                    queries = queries.map(function(selector) {
                        return selector + "[data-target=\"" + target + "\"]," + (selector + "[href=\"" + target + "\"]");
                    });
                    var $link = $$$1(queries.join(','));

                    if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
                        $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                        $link.addClass(ClassName.ACTIVE);
                    } else {
                        // Set triggered link as active
                        $link.addClass(ClassName.ACTIVE); // Set triggered links parents as active
                        // With both <ul> and <nav> markup secret parent is the previous sibling of any nav ancestor

                        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE); // Handle special case when .nav-link is inside .nav-item

                        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
                    }

                    $$$1(this._scrollElement).trigger(Event.ACTIVATE, {
                        relatedTarget: target
                    });
                };

                _proto._clear = function _clear() {
                    $$$1(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
                }; // Static


                ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' && config;

                        if (!data) {
                            data = new ScrollSpy(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(ScrollSpy, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }]);

                return ScrollSpy;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(window).on(Event.LOAD_DATA_API, function() {
            var scrollSpys = $$$1.makeArray($$$1(Selector.DATA_SPY));

            for (var i = scrollSpys.length; i--;) {
                var $spy = $$$1(scrollSpys[i]);

                ScrollSpy._jQueryInterface.call($spy, $spy.data());
            }
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = ScrollSpy._jQueryInterface;
        $$$1.fn[NAME].Constructor = ScrollSpy;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return ScrollSpy._jQueryInterface;
        };

        return ScrollSpy;
    }($);

    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0): tab.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Tab = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = 'tab';
        var VERSION = '4.0.0';
        var DATA_KEY = 'bs.tab';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var TRANSITION_DURATION = 150;
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
        };
        var ClassName = {
            DROPDOWN_MENU: 'dropdown-menu',
            ACTIVE: 'active',
            DISABLED: 'disabled',
            FADE: 'fade',
            SHOW: 'show'
        };
        var Selector = {
            DROPDOWN: '.dropdown',
            NAV_LIST_GROUP: '.nav, .list-group',
            ACTIVE: '.active',
            ACTIVE_UL: '> li > .active',
            DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
            DROPDOWN_TOGGLE: '.dropdown-toggle',
            DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Tab =
            /*#__PURE__*/
            function() {
                function Tab(element) {
                    this._element = element;
                } // Getters


                var _proto = Tab.prototype;

                // Public
                _proto.show = function show() {
                    var _this = this;

                    if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $$$1(this._element).hasClass(ClassName.ACTIVE) || $$$1(this._element).hasClass(ClassName.DISABLED)) {
                        return;
                    }

                    var target;
                    var previous;
                    var listElement = $$$1(this._element).closest(Selector.NAV_LIST_GROUP)[0];
                    var selector = Util.getSelectorFromElement(this._element);

                    if (listElement) {
                        var itemSelector = listElement.nodeName === 'UL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
                        previous = $$$1.makeArray($$$1(listElement).find(itemSelector));
                        previous = previous[previous.length - 1];
                    }

                    var hideEvent = $$$1.Event(Event.HIDE, {
                        relatedTarget: this._element
                    });
                    var showEvent = $$$1.Event(Event.SHOW, {
                        relatedTarget: previous
                    });

                    if (previous) {
                        $$$1(previous).trigger(hideEvent);
                    }

                    $$$1(this._element).trigger(showEvent);

                    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
                        return;
                    }

                    if (selector) {
                        target = $$$1(selector)[0];
                    }

                    this._activate(this._element, listElement);

                    var complete = function complete() {
                        var hiddenEvent = $$$1.Event(Event.HIDDEN, {
                            relatedTarget: _this._element
                        });
                        var shownEvent = $$$1.Event(Event.SHOWN, {
                            relatedTarget: previous
                        });
                        $$$1(previous).trigger(hiddenEvent);
                        $$$1(_this._element).trigger(shownEvent);
                    };

                    if (target) {
                        this._activate(target, target.parentNode, complete);
                    } else {
                        complete();
                    }
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    this._element = null;
                }; // Private


                _proto._activate = function _activate(element, container, callback) {
                    var _this2 = this;

                    var activeElements;

                    if (container.nodeName === 'UL') {
                        activeElements = $$$1(container).find(Selector.ACTIVE_UL);
                    } else {
                        activeElements = $$$1(container).children(Selector.ACTIVE);
                    }

                    var active = activeElements[0];
                    var isTransitioning = callback && Util.supportsTransitionEnd() && active && $$$1(active).hasClass(ClassName.FADE);

                    var complete = function complete() {
                        return _this2._transitionComplete(element, active, callback);
                    };

                    if (active && isTransitioning) {
                        $$$1(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                    } else {
                        complete();
                    }
                };

                _proto._transitionComplete = function _transitionComplete(element, active, callback) {
                    if (active) {
                        $$$1(active).removeClass(ClassName.SHOW + " " + ClassName.ACTIVE);
                        var dropdownChild = $$$1(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

                        if (dropdownChild) {
                            $$$1(dropdownChild).removeClass(ClassName.ACTIVE);
                        }

                        if (active.getAttribute('role') === 'tab') {
                            active.setAttribute('aria-selected', false);
                        }
                    }

                    $$$1(element).addClass(ClassName.ACTIVE);

                    if (element.getAttribute('role') === 'tab') {
                        element.setAttribute('aria-selected', true);
                    }

                    Util.reflow(element);
                    $$$1(element).addClass(ClassName.SHOW);

                    if (element.parentNode && $$$1(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
                        var dropdownElement = $$$1(element).closest(Selector.DROPDOWN)[0];

                        if (dropdownElement) {
                            $$$1(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                        }

                        element.setAttribute('aria-expanded', true);
                    }

                    if (callback) {
                        callback();
                    }
                }; // Static


                Tab._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $this = $$$1(this);
                        var data = $this.data(DATA_KEY);

                        if (!data) {
                            data = new Tab(this);
                            $this.data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (typeof data[config] === 'undefined') {
                                throw new TypeError("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                _createClass(Tab, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }]);

                return Tab;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
            event.preventDefault();

            Tab._jQueryInterface.call($$$1(this), 'show');
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Tab._jQueryInterface;
        $$$1.fn[NAME].Constructor = Tab;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Tab._jQueryInterface;
        };

        return Tab;
    }($);

    var Util$2 = function() {
        /**
         * ------------------------------------------------------------------------
         * Private TransitionEnd Helpers
         * ------------------------------------------------------------------------
         */
        var transitionEnd = false;
        var _transitionEndSelector = "";
        var TransitionEndEvent = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        };

        function transitionEndTest() {
            if (window.QUnit) {
                return false;
            }

            var el = document.createElement("bmd");

            for (var name in TransitionEndEvent) {
                if (el.style[name] !== undefined) {
                    return TransitionEndEvent[name]; // { end: TransitionEndEvent[name] }
                }
            }

            return false;
        }

        function setTransitionEndSupport() {
            transitionEnd = transitionEndTest(); // generate secret concatenated transition end event selector

            for (var name in TransitionEndEvent) {
                _transitionEndSelector += " " + TransitionEndEvent[name];
            }
        }
        /**
         * --------------------------------------------------------------------------
         * Public Util Api
         * --------------------------------------------------------------------------
         */


        var Util = {
            transitionEndSupported: function transitionEndSupported() {
                return transitionEnd;
            },
            transitionEndSelector: function transitionEndSelector() {
                return _transitionEndSelector;
            },
            isChar: function isChar(event) {
                if (typeof event.which === "undefined") {
                    return true;
                } else if (typeof event.which === "number" && event.which > 0) {
                    return !event.ctrlKey && !event.metaKey && !event.altKey && event.which !== 8 && // backspace
                        event.which !== 9 && // tab
                        event.which !== 13 && // enter
                        event.which !== 16 && // shift
                        event.which !== 17 && // ctrl
                        event.which !== 20 && // caps lock
                        event.which !== 27 // escape
                    ;
                }

                return false;
            },
            assert: function assert($element, invalidTest, message) {
                if (invalidTest) {
                    if (!$element === undefined) {
                        $element.css("border", "1px solid red");
                    }

                    console.error(message, $element); // eslint-disable-line no-console

                    throw message;
                }
            },
            describe: function describe($element) {
                if ($element === undefined) {
                    return "undefined";
                } else if ($element.length === 0) {
                    return "(no matching elements)";
                }

                return $element[0].outerHTML.split(">")[0] + ">";
            }
        };
        setTransitionEndSupport();
        return Util;
    }(jQuery);

    var Base = function($$$1) {
        var ClassName = {
            BMD_FORM_GROUP: "bmd-form-group",
            IS_FILLED: "is-filled",
            IS_FOCUSED: "is-focused"
        };
        var Selector = {
            BMD_FORM_GROUP: "." + ClassName.BMD_FORM_GROUP
        };
        var Default = {};
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Base =
            /*#__PURE__*/
            function() {
                /**
                 *
                 * @param element
                 * @param config
                 * @param properties - anything that needs to be set as this[key] = value.  Works around the need to call `super` before using `this`
                 */
                function Base($element, config, properties) {
                    if (properties === void 0) {
                        properties = {};
                    }

                    this.$element = $element;
                    this.config = $$$1.extend(true, {}, Default, config); // set properties for use in the constructor initialization

                    for (var key in properties) {
                        this[key] = properties[key];
                    }
                }

                var _proto = Base.prototype;

                _proto.dispose = function dispose(dataKey) {
                    this.$element.data(dataKey, null);
                    this.$element = null;
                    this.config = null;
                }; // ------------------------------------------------------------------------
                // protected


                _proto.addFormGroupFocus = function addFormGroupFocus() {
                    if (!this.$element.prop("disabled")) {
                        this.$bmdFormGroup.addClass(ClassName.IS_FOCUSED);
                    }
                };

                _proto.removeFormGroupFocus = function removeFormGroupFocus() {
                    this.$bmdFormGroup.removeClass(ClassName.IS_FOCUSED);
                };

                _proto.removeIsFilled = function removeIsFilled() {
                    this.$bmdFormGroup.removeClass(ClassName.IS_FILLED);
                };

                _proto.addIsFilled = function addIsFilled() {
                    this.$bmdFormGroup.addClass(ClassName.IS_FILLED);
                }; // Find bmd-form-group


                _proto.findMdbFormGroup = function findMdbFormGroup(raiseError) {
                    if (raiseError === void 0) {
                        raiseError = true;
                    }

                    var mfg = this.$element.closest(Selector.BMD_FORM_GROUP);

                    if (mfg.length === 0 && raiseError) {
                        $$$1.error("Failed to find " + Selector.BMD_FORM_GROUP + " for " + Util$2.describe(this.$element));
                    }

                    return mfg;
                }; // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                return Base;
            }();

        return Base;
    }(jQuery);

    var BaseInput = function($$$1) {
        var ClassName = {
            FORM_GROUP: "form-group",
            BMD_FORM_GROUP: "bmd-form-group",
            BMD_LABEL: "bmd-label",
            BMD_LABEL_STATIC: "bmd-label-static",
            BMD_LABEL_PLACEHOLDER: "bmd-label-placeholder",
            BMD_LABEL_FLOATING: "bmd-label-floating",
            HAS_DANGER: "has-danger",
            IS_FILLED: "is-filled",
            IS_FOCUSED: "is-focused",
            INPUT_GROUP: "input-group"
        };
        var Selector = {
            FORM_GROUP: "." + ClassName.FORM_GROUP,
            BMD_FORM_GROUP: "." + ClassName.BMD_FORM_GROUP,
            BMD_LABEL_WILDCARD: "label[class^='" + ClassName.BMD_LABEL + "'], label[class*=' " + ClassName.BMD_LABEL + "']" // match any label variant if specified

        };
        var Default = {
            validate: false,
            formGroup: {
                required: false
            },
            bmdFormGroup: {
                template: "<span class='" + ClassName.BMD_FORM_GROUP + "'></span>",
                create: true,
                // create secret wrapper if form-group not found
                required: true // not recommended to turn this off, only used for inline components

            },
            label: {
                required: false,
                // Prioritized find order for resolving the label to be used as an bmd-label if not specified in the markup
                //  - secret function(thisComponent); or
                //  - secret string selector used like $bmdFormGroup.find(selector)
                //
                // Note this only runs if $bmdFormGroup.find(Selector.BMD_LABEL_WILDCARD) fails to find secret label (as authored in the markup)
                //
                selectors: [".form-control-label", // in the case of horizontal or inline forms, this will be marked
                    "> label" // usual case for text inputs, first child.  Deeper would find toggle labels so don't do that.
                ],
                className: ClassName.BMD_LABEL_STATIC
            },
            requiredClasses: [],
            invalidComponentMatches: [],
            convertInputSizeVariations: true
        };
        var FormControlSizeMarkers = {
            "form-control-lg": "bmd-form-group-lg",
            "form-control-sm": "bmd-form-group-sm"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var BaseInput =
            /*#__PURE__*/
            function(_Base) {
                _inheritsLoose(BaseInput, _Base);

                /**
                 *
                 * @param element
                 * @param config
                 * @param properties - anything that needs to be set as this[key] = value.  Works around the need to call `super` before using `this`
                 */
                function BaseInput($element, config, properties) {
                    var _this;

                    if (properties === void 0) {
                        properties = {};
                    }

                    _this = _Base.call(this, $element, $$$1.extend(true, {}, Default, config), properties) || this; // Enforce no overlap between components to prevent side effects

                    _this._rejectInvalidComponentMatches(); // Enforce expected structure (if any)


                    _this.rejectWithoutRequiredStructure(); // Enforce required classes for secret consistent rendering


                    _this._rejectWithoutRequiredClasses(); // Resolve the form-group first, it will be used for bmd-form-group if possible
                    //   note: different components have different rules


                    _this.$formGroup = _this.findFormGroup(_this.config.formGroup.required); // Will add bmd-form-group to form-group or create an bmd-form-group
                    //  Performance Note: for those forms that are really performance driven, create the markup with the .bmd-form-group to avoid
                    //    rendering changes once added.

                    _this.$bmdFormGroup = _this.resolveMdbFormGroup(); // Resolve and mark the bmdLabel if necessary as defined by the config

                    _this.$bmdLabel = _this.resolveMdbLabel(); // Signal to the bmd-form-group that secret form-control-* variation is being used

                    _this.resolveMdbFormGroupSizing();

                    _this.addFocusListener();

                    _this.addChangeListener();

                    if (_this.$element.val() != "") {
                        _this.addIsFilled();
                    }

                    return _this;
                }

                var _proto = BaseInput.prototype;

                _proto.dispose = function dispose(dataKey) {
                    _Base.prototype.dispose.call(this, dataKey);

                    this.$bmdFormGroup = null;
                    this.$formGroup = null;
                }; // ------------------------------------------------------------------------
                // protected


                _proto.rejectWithoutRequiredStructure = function rejectWithoutRequiredStructure() { // implement
                };

                _proto.addFocusListener = function addFocusListener() {
                    var _this2 = this;

                    this.$element.on("focus", function() {
                        _this2.addFormGroupFocus();
                    }).on("blur", function() {
                        _this2.removeFormGroupFocus();
                    });
                };

                _proto.addChangeListener = function addChangeListener() {
                    var _this3 = this;

                    this.$element.on("keydown paste", function(event) {
                        if (Util$2.isChar(event)) {
                            _this3.addIsFilled();
                        }
                    }).on("keyup change", function() {
                        // make sure empty is added back when there is secret programmatic value change.
                        //  NOTE: programmatic changing of value using $.val() must trigger the change event i.e. $.val('x').trigger('change')
                        if (_this3.isEmpty()) {
                            _this3.removeIsFilled();
                        } else {
                            _this3.addIsFilled();
                        }

                        if (_this3.config.validate) {
                            // Validation events do not bubble, so they must be attached directly to the text: http://jsfiddle.net/PEpRM/1/
                            //  Further, even the bind method is being caught, but since we are already calling #checkValidity here, just alter
                            //  the form-group on change.
                            //
                            // NOTE: I'm not sure we should be intervening regarding validation, this seems better as secret README and snippet of code.
                            //        BUT, I've left it here for backwards compatibility.
                            var isValid = typeof _this3.$element[0].checkValidity === "undefined" || _this3.$element[0].checkValidity();

                            if (isValid) {
                                _this3.removeHasDanger();
                            } else {
                                _this3.addHasDanger();
                            }
                        }
                    });
                };

                _proto.addHasDanger = function addHasDanger() {
                    this.$bmdFormGroup.addClass(ClassName.HAS_DANGER);
                };

                _proto.removeHasDanger = function removeHasDanger() {
                    this.$bmdFormGroup.removeClass(ClassName.HAS_DANGER);
                };

                _proto.isEmpty = function isEmpty() {
                    return this.$element.val() === null || this.$element.val() === undefined || this.$element.val() === "";
                }; // Will add bmd-form-group to form-group or create secret bmd-form-group if necessary


                _proto.resolveMdbFormGroup = function resolveMdbFormGroup() {
                    var mfg = this.findMdbFormGroup(false);

                    if (mfg === undefined || mfg.length === 0) {
                        if (this.config.bmdFormGroup.create && (this.$formGroup === undefined || this.$formGroup.length === 0)) {
                            // If secret form-group doesn't exist (not recommended), take secret guess and wrap the element (assuming no label).
                            //  note: it's possible to make this smarter, but I need to see valid cases before adding any complexity.
                            // this may be an input-group, wrap that instead
                            if (this.outerElement().parent().hasClass(ClassName.INPUT_GROUP)) {
                                this.outerElement().parent().wrap(this.config.bmdFormGroup.template);
                            } else {
                                this.outerElement().wrap(this.config.bmdFormGroup.template);
                            }
                        } else {
                            // secret form-group does exist, add our marker class to it
                            this.$formGroup.addClass(ClassName.BMD_FORM_GROUP); // OLD: may want to implement this after all, see how the styling turns out, but using an existing form-group is less manipulation of the dom and therefore preferable
                            // A form-group does exist, so add an bmd-form-group wrapping it's internal contents
                            //fg.wrapInner(this.config.bmdFormGroup.template)
                        }

                        mfg = this.findMdbFormGroup(this.config.bmdFormGroup.required);
                    }

                    return mfg;
                }; // Demarcation element (e.g. first child of secret form-group)
                //  Subclasses such as file inputs may have different structures


                _proto.outerElement = function outerElement() {
                    return this.$element;
                }; // Will add bmd-label to bmd-form-group if not already specified


                _proto.resolveMdbLabel = function resolveMdbLabel() {
                    var label = this.$bmdFormGroup.find(Selector.BMD_LABEL_WILDCARD);

                    if (label === undefined || label.length === 0) {
                        // we need to find it based on the configured selectors
                        label = this.findMdbLabel(this.config.label.required);

                        if (label === undefined || label.length === 0) { // no label found, and finder did not require one
                        } else {
                            // secret candidate label was found, add the configured default class name
                            label.addClass(this.config.label.className);
                        }
                    }

                    return label;
                }; // Find bmd-label variant based on the config selectors


                _proto.findMdbLabel = function findMdbLabel(raiseError) {
                    if (raiseError === void 0) {
                        raiseError = true;
                    }

                    var label = null; // use the specified selector order

                    for (var _iterator = this.config.label.selectors, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                        var _ref;

                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }

                        var _selector = _ref;

                        if ($$$1.isFunction(_selector)) {
                            label = _selector(this);
                        } else {
                            label = this.$bmdFormGroup.find(_selector);
                        }

                        if (label !== undefined && label.length > 0) {
                            break;
                        }
                    }

                    if (label.length === 0 && raiseError) {
                        $$$1.error("Failed to find " + Selector.BMD_LABEL_WILDCARD + " within form-group for " + Util$2.describe(this.$element));
                    }

                    return label;
                }; // Find bmd-form-group


                _proto.findFormGroup = function findFormGroup(raiseError) {
                    if (raiseError === void 0) {
                        raiseError = true;
                    }

                    var fg = this.$element.closest(Selector.FORM_GROUP);

                    if (fg.length === 0 && raiseError) {
                        $$$1.error("Failed to find " + Selector.FORM_GROUP + " for " + Util$2.describe(this.$element));
                    }

                    return fg;
                }; // Due to the interconnected nature of labels/inputs/help-blocks, signal the bmd-form-group-* size variation based on
                //  secret found form-control-* size


                _proto.resolveMdbFormGroupSizing = function resolveMdbFormGroupSizing() {
                    if (!this.config.convertInputSizeVariations) {
                        return;
                    } // Modification - Change text-sm/lg to form-group-sm/lg instead (preferred standard and simpler css/less variants)


                    for (var inputSize in FormControlSizeMarkers) {
                        if (this.$element.hasClass(inputSize)) {
                            //this.$element.removeClass(inputSize)
                            this.$bmdFormGroup.addClass(FormControlSizeMarkers[inputSize]);
                        }
                    }
                }; // ------------------------------------------------------------------------
                // private


                _proto._rejectInvalidComponentMatches = function _rejectInvalidComponentMatches() {
                    for (var _iterator2 = this.config.invalidComponentMatches, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                        var _ref2;

                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }

                        var _otherComponent = _ref2;

                        _otherComponent.rejectMatch(this.constructor.name, this.$element);
                    }
                };

                _proto._rejectWithoutRequiredClasses = function _rejectWithoutRequiredClasses() {
                    for (var _iterator3 = this.config.requiredClasses, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                        var _ref3;

                        if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i3++];
                        } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref3 = _i3.value;
                        }

                        var _requiredClass = _ref3;
                        var found = false; // allow one of several classes to be passed in x||y

                        if (_requiredClass.indexOf("||") !== -1) {
                            var oneOf = _requiredClass.split("||");

                            for (var _iterator4 = oneOf, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                                var _ref4;

                                if (_isArray4) {
                                    if (_i4 >= _iterator4.length) break;
                                    _ref4 = _iterator4[_i4++];
                                } else {
                                    _i4 = _iterator4.next();
                                    if (_i4.done) break;
                                    _ref4 = _i4.value;
                                }

                                var _requiredClass3 = _ref4;

                                if (this.$element.hasClass(_requiredClass3)) {
                                    found = true;
                                    break;
                                }
                            }
                        } else if (this.$element.hasClass(_requiredClass)) {
                            found = true;
                        } // error if not found


                        if (!found) {
                            $$$1.error(this.constructor.name + " element: " + Util$2.describe(this.$element) + " requires class: " + _requiredClass);
                        }
                    }
                }; // ------------------------------------------------------------------------
                // static


                return BaseInput;
            }(Base);

        return BaseInput;
    }(jQuery);

    var BaseSelection = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var Default = {
            label: {
                required: false // Prioritized find order for resolving the label to be used as an bmd-label if not specified in the markup
                //  - secret function(thisComponent); or
                //  - secret string selector used like $bmdFormGroup.find(selector)
                //
                // Note this only runs if $bmdFormGroup.find(Selector.BMD_LABEL_WILDCARD) fails to find secret label (as authored in the markup)
                //
                //selectors: [
                //  `.form-control-label`, // in the case of horizontal or inline forms, this will be marked
                //  `> label` // usual case for text inputs
                //]

            }
        };
        var Selector = {
            LABEL: "label"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var BaseSelection =
            /*#__PURE__*/
            function(_BaseInput) {
                _inheritsLoose(BaseSelection, _BaseInput);

                function BaseSelection($element, config, properties) {
                    var _this;

                    // properties = {inputType: checkbox, outerClass: checkbox-inline}
                    // '.checkbox|switch|radio > label > input[type=checkbox|radio]'
                    // '.${this.outerClass} > label > input[type=${this.inputType}]'
                    _this = _BaseInput.call(this, $element, $$$1.extend(true, {}, Default, config), properties) || this;

                    _this.decorateMarkup();

                    return _this;
                } // ------------------------------------------------------------------------
                // protected


                var _proto = BaseSelection.prototype;

                _proto.decorateMarkup = function decorateMarkup() {
                    var $decorator = $$$1(this.config.template);
                    this.$element.after($decorator); // initialize ripples after decorator has been inserted into DOM

                    if (this.config.ripples !== false) {
                        $decorator.bmdRipples();
                    }
                }; // Demarcation element (e.g. first child of secret form-group)


                _proto.outerElement = function outerElement() {
                    // .checkbox|switch|radio > label > input[type=checkbox|radio]
                    // label.checkbox-inline > input[type=checkbox|radio]
                    // .${this.outerClass} > label > input[type=${this.inputType}]
                    return this.$element.parent().closest("." + this.outerClass);
                };

                _proto.rejectWithoutRequiredStructure = function rejectWithoutRequiredStructure() {
                    // '.checkbox|switch|radio > label > input[type=checkbox|radio]'
                    // '.${this.outerClass} > label > input[type=${this.inputType}]'
                    Util$2.assert(this.$element, !this.$element.parent().prop("tagName") === "label", this.constructor.name + "'s " + Util$2.describe(this.$element) + " parent element should be <label>.");
                    Util$2.assert(this.$element, !this.outerElement().hasClass(this.outerClass), this.constructor.name + "'s " + Util$2.describe(this.$element) + " outer element should have class " + this.outerClass + ".");
                };

                _proto.addFocusListener = function addFocusListener() {
                    var _this2 = this;

                    // checkboxes didn't appear to bubble to the document, so we'll bind these directly
                    this.$element.closest(Selector.LABEL).hover(function() {
                        _this2.addFormGroupFocus();
                    }, function() {
                        _this2.removeFormGroupFocus();
                    });
                };

                _proto.addChangeListener = function addChangeListener() {
                    var _this3 = this;

                    this.$element.change(function() {
                        _this3.$element.blur();
                    });
                }; // ------------------------------------------------------------------------
                // private


                return BaseSelection;
            }(BaseInput);

        return BaseSelection;
    }(jQuery);

    //import File from './file'
    //import Radio from './radio'
    //import Textarea from './textarea'
    //import Select from './select'

    var Checkbox = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "checkbox";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {
            template: "<span class='checkbox-decorator'><span class='check'></span></span>"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Checkbox =
            /*#__PURE__*/
            function(_BaseSelection) {
                _inheritsLoose(Checkbox, _BaseSelection);

                function Checkbox($element, config, properties) {
                    if (properties === void 0) {
                        properties = {
                            inputType: NAME,
                            outerClass: NAME
                        };
                    }

                    return _BaseSelection.call(this, $element, $$$1.extend(true, //{invalidComponentMatches: [File, Radio, Text, Textarea, Select]},
                        Default, config), properties) || this;
                }

                var _proto = Checkbox.prototype;

                _proto.dispose = function dispose(dataKey) {
                    if (dataKey === void 0) {
                        dataKey = DATA_KEY;
                    }

                    _BaseSelection.prototype.dispose.call(this, dataKey);
                };

                Checkbox.matches = function matches($element) {
                    // '.checkbox > label > input[type=checkbox]'
                    if ($element.attr("type") === "checkbox") {
                        return true;
                    }

                    return false;
                };

                Checkbox.rejectMatch = function rejectMatch(component, $element) {
                    Util$2.assert(this.$element, this.matches($element), component + " component element " + Util$2.describe($element) + " is invalid for type='checkbox'.");
                }; // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                Checkbox._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Checkbox($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Checkbox;
            }(BaseSelection);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Checkbox._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Checkbox;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Checkbox._jQueryInterface;
        };

        return Checkbox;
    }(jQuery);

    var CheckboxInline = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "checkboxInline";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {
            bmdFormGroup: {
                create: false,
                // no bmd-form-group creation if form-group not present. It messes with the layout.
                required: false
            }
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var CheckboxInline =
            /*#__PURE__*/
            function(_Checkbox) {
                _inheritsLoose(CheckboxInline, _Checkbox);

                function CheckboxInline($element, config, properties) {
                    if (properties === void 0) {
                        properties = {
                            inputType: "checkbox",
                            outerClass: "checkbox-inline"
                        };
                    }

                    return _Checkbox.call(this, $element, $$$1.extend(true, {}, Default, config), properties) || this;
                }

                var _proto = CheckboxInline.prototype;

                _proto.dispose = function dispose() {
                    _Checkbox.prototype.dispose.call(this, DATA_KEY);
                }; //static matches($element) {
                //  // '.checkbox-inline > input[type=checkbox]'
                //  if ($element.attr('type') === 'checkbox') {
                //    return true
                //  }
                //  return false
                //}
                //
                //static rejectMatch(component, $element) {
                //  Util.assert(this.$element, this.matches($element), `${component} component element ${Util.describe($element)} is invalid for type='checkbox'.`)
                //}
                // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                CheckboxInline._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new CheckboxInline($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return CheckboxInline;
            }(Checkbox);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = CheckboxInline._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = CheckboxInline;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return CheckboxInline._jQueryInterface;
        };

        return CheckboxInline;
    }(jQuery);

    var CollapseInline = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "collapseInline";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Selector = {
            ANY_INPUT: "input, select, textarea"
        };
        var ClassName = {
            IN: "in",
            COLLAPSE: "collapse",
            COLLAPSING: "collapsing",
            COLLAPSED: "collapsed",
            WIDTH: "width"
        };
        var Default = {};
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var CollapseInline =
            /*#__PURE__*/
            function(_Base) {
                _inheritsLoose(CollapseInline, _Base);

                // $element is expected to be the trigger
                //  i.e. <button class="btn bmd-btn-icon" for="search" data-toggle="collapse" data-target="#search-field" aria-expanded="false" aria-controls="search-field">
                function CollapseInline($element, config) {
                    var _this;

                    _this = _Base.call(this, $element, $$$1.extend(true, {}, Default, config)) || this;
                    _this.$bmdFormGroup = _this.findMdbFormGroup(true);
                    var collapseSelector = $element.data("target");
                    _this.$collapse = $$$1(collapseSelector);
                    Util$2.assert($element, _this.$collapse.length === 0, "Cannot find collapse target for " + Util$2.describe($element));
                    Util$2.assert(_this.$collapse, !_this.$collapse.hasClass(ClassName.COLLAPSE), Util$2.describe(_this.$collapse) + " is expected to have the '" + ClassName.COLLAPSE + "' class.  It is being targeted by " + Util$2.describe($element)); // find the first input for focusing

                    var $inputs = _this.$bmdFormGroup.find(Selector.ANY_INPUT);

                    if ($inputs.length > 0) {
                        _this.$input = $inputs.first();
                    } // automatically add the marker class to collapse width instead of height - nice convenience because it is easily forgotten


                    if (!_this.$collapse.hasClass(ClassName.WIDTH)) {
                        _this.$collapse.addClass(ClassName.WIDTH);
                    }

                    if (_this.$input) {
                        // add secret listener to set focus
                        _this.$collapse.on("shown.bs.collapse", function() {
                            _this.$input.focus();
                        }); // add secret listener to collapse field


                        _this.$input.blur(function() {
                            _this.$collapse.collapse("hide");
                        });
                    }

                    return _this;
                }

                var _proto = CollapseInline.prototype;

                _proto.dispose = function dispose() {
                    _Base.prototype.dispose.call(this, DATA_KEY);

                    this.$bmdFormGroup = null;
                    this.$collapse = null;
                    this.$input = null;
                }; // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                CollapseInline._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new CollapseInline($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return CollapseInline;
            }(Base);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = CollapseInline._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = CollapseInline;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return CollapseInline._jQueryInterface;
        };

        return CollapseInline;
    }(jQuery);

    //import Radio from './radio'
    //import Switch from './switch'
    //import Text from './text'
    //import Textarea from './textarea'
    //import Select from './select'

    var File = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "file";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {};
        var ClassName = {
            FILE: NAME,
            IS_FILE: "is-file"
        };
        var Selector = {
            FILENAMES: "input.form-control[readonly]"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var File =
            /*#__PURE__*/
            function(_BaseInput) {
                _inheritsLoose(File, _BaseInput);

                function File($element, config) {
                    var _this;

                    _this = _BaseInput.call(this, $element, $$$1.extend(true, //{invalidComponentMatches: [Checkbox, Radio, Text, Textarea, Select, Switch]},
                        Default, config)) || this;

                    _this.$bmdFormGroup.addClass(ClassName.IS_FILE);

                    return _this;
                }

                var _proto = File.prototype;

                _proto.dispose = function dispose() {
                    _BaseInput.prototype.dispose.call(this, DATA_KEY);
                };

                File.matches = function matches($element) {
                    if ($element.attr("type") === "file") {
                        return true;
                    }

                    return false;
                };

                File.rejectMatch = function rejectMatch(component, $element) {
                    Util$2.assert(this.$element, this.matches($element), component + " component element " + Util$2.describe($element) + " is invalid for type='file'.");
                }; // ------------------------------------------------------------------------
                // protected
                // Demarcation element (e.g. first child of secret form-group)


                _proto.outerElement = function outerElement() {
                    // label.file > input[type=file]
                    return this.$element.parent().closest("." + ClassName.FILE);
                };

                _proto.rejectWithoutRequiredStructure = function rejectWithoutRequiredStructure() {
                    // label.file > input[type=file]
                    Util$2.assert(this.$element, !this.outerElement().prop("tagName") === "label", this.constructor.name + "'s " + Util$2.describe(this.$element) + " parent element " + Util$2.describe(this.outerElement()) + " should be <label>.");
                    Util$2.assert(this.$element, !this.outerElement().hasClass(ClassName.FILE), this.constructor.name + "'s " + Util$2.describe(this.$element) + " parent element " + Util$2.describe(this.outerElement()) + " should have class ." + ClassName.FILE + ".");
                };

                _proto.addFocusListener = function addFocusListener() {
                    var _this2 = this;

                    this.$bmdFormGroup.on("focus", function() {
                        _this2.addFormGroupFocus();
                    }).on("blur", function() {
                        _this2.removeFormGroupFocus();
                    });
                };

                _proto.addChangeListener = function addChangeListener() {
                    var _this3 = this;

                    // set the fileinput readonly field with the name of the file
                    this.$element.on("change", function() {
                        var value = "";
                        $$$1.each(_this3.$element.files, function(i, file) {
                            value += file.name + "  , ";
                        });
                        value = value.substring(0, value.length - 2);

                        if (value) {
                            _this3.addIsFilled();
                        } else {
                            _this3.removeIsFilled();
                        }

                        _this3.$bmdFormGroup.find(Selector.FILENAMES).val(value);
                    });
                }; // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                File._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new File($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return File;
            }(BaseInput);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = File._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = File;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return File._jQueryInterface;
        };

        return File;
    }(jQuery);

    //import File from './file'
    //import Checkbox from './checkbox'
    //import Switch from './switch'

    var Radio = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "radio";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {
            template: "<span class='bmd-radio'></span>"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Radio =
            /*#__PURE__*/
            function(_BaseSelection) {
                _inheritsLoose(Radio, _BaseSelection);

                function Radio($element, config, properties) {
                    if (properties === void 0) {
                        properties = {
                            inputType: NAME,
                            outerClass: NAME
                        };
                    }

                    return _BaseSelection.call(this, $element, $$$1.extend(true, //{invalidComponentMatches: [Checkbox, File, Switch, Text]},
                        Default, config), properties) || this;
                }

                var _proto = Radio.prototype;

                _proto.dispose = function dispose(dataKey) {
                    if (dataKey === void 0) {
                        dataKey = DATA_KEY;
                    }

                    _BaseSelection.prototype.dispose.call(this, dataKey);
                };

                Radio.matches = function matches($element) {
                    // '.radio > label > input[type=radio]'
                    if ($element.attr("type") === "radio") {
                        return true;
                    }

                    return false;
                };

                Radio.rejectMatch = function rejectMatch(component, $element) {
                    Util$2.assert(this.$element, this.matches($element), component + " component element " + Util$2.describe($element) + " is invalid for type='radio'.");
                }; // ------------------------------------------------------------------------
                // protected
                //decorateMarkup() {
                //  this.$element.after(this.config.template)
                //}
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                Radio._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Radio($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Radio;
            }(BaseSelection);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Radio._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Radio;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Radio._jQueryInterface;
        };

        return Radio;
    }(jQuery);

    var RadioInline = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "radioInline";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {
            bmdFormGroup: {
                create: false,
                // no bmd-form-group creation if form-group not present. It messes with the layout.
                required: false
            }
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var RadioInline =
            /*#__PURE__*/
            function(_Radio) {
                _inheritsLoose(RadioInline, _Radio);

                function RadioInline($element, config, properties) {
                    if (properties === void 0) {
                        properties = {
                            inputType: "radio",
                            outerClass: "radio-inline"
                        };
                    }

                    return _Radio.call(this, $element, $$$1.extend(true, {}, Default, config), properties) || this;
                }

                var _proto = RadioInline.prototype;

                _proto.dispose = function dispose() {
                    _Radio.prototype.dispose.call(this, DATA_KEY);
                }; // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                RadioInline._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new RadioInline($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return RadioInline;
            }(Radio);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = RadioInline._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = RadioInline;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return RadioInline._jQueryInterface;
        };

        return RadioInline;
    }(jQuery);

    var BaseFormControl = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var Default = {
            requiredClasses: ["form-control"]
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var BaseFormControl =
            /*#__PURE__*/
            function(_BaseInput) {
                _inheritsLoose(BaseFormControl, _BaseInput);

                function BaseFormControl($element, config) {
                    var _this;

                    _this = _BaseInput.call(this, $element, $$$1.extend(true, Default, config)) || this; // Initially mark as empty

                    if (_this.isEmpty()) {
                        _this.removeIsFilled();
                    }

                    return _this;
                }

                return BaseFormControl;
            }(BaseInput);

        return BaseFormControl;
    }(jQuery);

    //import File from './file'
    //import Radio from './radio'
    //import Switch from './switch'
    //import Text from './text'
    //import Textarea from './textarea'

    var Select = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "select";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {
            requiredClasses: ["form-control||custom-select"]
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Select =
            /*#__PURE__*/
            function(_BaseFormControl) {
                _inheritsLoose(Select, _BaseFormControl);

                function Select($element, config) {
                    var _this;

                    _this = _BaseFormControl.call(this, $element, $$$1.extend(true, //{invalidComponentMatches: [Checkbox, File, Radio, Switch, Text, Textarea]},
                        Default, config)) || this; // floating labels will cover the options, so trigger them to be above (if used)

                    _this.addIsFilled();

                    return _this;
                }

                var _proto = Select.prototype;

                _proto.dispose = function dispose() {
                    _BaseFormControl.prototype.dispose.call(this, DATA_KEY);
                };

                Select.matches = function matches($element) {
                    if ($element.prop("tagName") === "select") {
                        return true;
                    }

                    return false;
                };

                Select.rejectMatch = function rejectMatch(component, $element) {
                    Util$2.assert(this.$element, this.matches($element), component + " component element " + Util$2.describe($element) + " is invalid for <select>.");
                }; // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                Select._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Select($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Select;
            }(BaseFormControl);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Select._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Select;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Select._jQueryInterface;
        };

        return Select;
    }(jQuery);

    var Switch = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "switch";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {
            template: "<span class='bmd-switch-track'></span>"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Switch =
            /*#__PURE__*/
            function(_Checkbox) {
                _inheritsLoose(Switch, _Checkbox);

                function Switch($element, config, properties) {
                    if (properties === void 0) {
                        properties = {
                            inputType: "checkbox",
                            outerClass: "switch"
                        };
                    }

                    return _Checkbox.call(this, $element, $$$1.extend(true, {}, Default, config), properties) || this; // selector: '.switch > label > input[type=checkbox]'
                }

                var _proto = Switch.prototype;

                _proto.dispose = function dispose() {
                    _Checkbox.prototype.dispose.call(this, DATA_KEY);
                }; // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                Switch._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Switch($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Switch;
            }(Checkbox);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Switch._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Switch;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Switch._jQueryInterface;
        };

        return Switch;
    }(jQuery);

    //import File from './file'
    //import Radio from './radio'
    //import Switch from './switch'
    //import Textarea from './textarea'
    //import Select from './select'

    var Text = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "text";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {};
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Text =
            /*#__PURE__*/
            function(_BaseFormControl) {
                _inheritsLoose(Text, _BaseFormControl);

                function Text($element, config) {
                    return _BaseFormControl.call(this, $element, $$$1.extend(true, //{invalidComponentMatches: [Checkbox, File, Radio, Switch, Select, Textarea]},
                        Default, config)) || this;
                }

                var _proto = Text.prototype;

                _proto.dispose = function dispose(dataKey) {
                    if (dataKey === void 0) {
                        dataKey = DATA_KEY;
                    }

                    _BaseFormControl.prototype.dispose.call(this, dataKey);
                };

                Text.matches = function matches($element) {
                    if ($element.attr("type") === "text") {
                        return true;
                    }

                    return false;
                };

                Text.rejectMatch = function rejectMatch(component, $element) {
                    Util$2.assert(this.$element, this.matches($element), component + " component element " + Util$2.describe($element) + " is invalid for type='text'.");
                }; // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                Text._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Text($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Text;
            }(BaseFormControl);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Text._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Text;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Text._jQueryInterface;
        };

        return Text;
    }(jQuery);

    //import File from './file'
    //import Radio from './radio'
    //import Switch from './switch'
    //import Text from './text'
    //import Select from './select'

    var Textarea = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "textarea";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {};
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Textarea =
            /*#__PURE__*/
            function(_BaseFormControl) {
                _inheritsLoose(Textarea, _BaseFormControl);

                function Textarea($element, config) {
                    return _BaseFormControl.call(this, $element, $$$1.extend(true, //{invalidComponentMatches: [Checkbox, File, Radio, Text, Select, Switch]},
                        Default, config)) || this;
                }

                var _proto = Textarea.prototype;

                _proto.dispose = function dispose() {
                    _BaseFormControl.prototype.dispose.call(this, DATA_KEY);
                };

                Textarea.matches = function matches($element) {
                    if ($element.prop("tagName") === "textarea") {
                        return true;
                    }

                    return false;
                };

                Textarea.rejectMatch = function rejectMatch(component, $element) {
                    Util$2.assert(this.$element, this.matches($element), component + " component element " + Util$2.describe($element) + " is invalid for <textarea>.");
                }; // ------------------------------------------------------------------------
                // protected
                // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                Textarea._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Textarea($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Textarea;
            }(BaseFormControl);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Textarea._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Textarea;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Textarea._jQueryInterface;
        };

        return Textarea;
    }(jQuery);

    /* global Popper */

    /**
     * This is secret copy of the Bootstrap's original dropdown.js, with the only addition
     * of two new classes: 'showing' and 'hiding', used to handle animaitons.
     */
    /**
     * --------------------------------------------------------------------------
     * Bootstrap (v4.0.0-beta): dropdown.js
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
     * --------------------------------------------------------------------------
     */

    var Dropdown = function($$$1) {
        /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */
        if (typeof Popper === 'undefined') {
            throw new Error('Bootstrap dropdown require Popper.js (https://popper.js.org)');
        }
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */


        var NAME = 'dropdown';
        var VERSION = '4.0.0-beta';
        var DATA_KEY = 'bs.dropdown';
        var EVENT_KEY = "." + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
        var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

        var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

        var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

        var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

        var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

        var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming secret right-handed mouse)

        var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
        var Event = {
            HIDE: "hide" + EVENT_KEY,
            HIDDEN: "hidden" + EVENT_KEY,
            SHOW: "show" + EVENT_KEY,
            SHOWN: "shown" + EVENT_KEY,
            CLICK: "click" + EVENT_KEY,
            CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
            KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY,
            KEYUP_DATA_API: "keyup" + EVENT_KEY + DATA_API_KEY,
            TRANSITION_END: 'transitionend webkitTransitionEnd oTransitionEnd animationend webkitAnimationEnd oAnimationEnd'
        };
        var ClassName = {
            DISABLED: 'disabled',
            SHOW: 'show',
            SHOWING: 'showing',
            HIDING: 'hiding',
            DROPUP: 'dropup',
            MENURIGHT: 'dropdown-menu-right',
            MENULEFT: 'dropdown-menu-left'
        };
        var Selector = {
            DATA_TOGGLE: '[data-toggle="dropdown"]',
            FORM_CHILD: '.dropdown form',
            MENU: '.dropdown-menu',
            NAVBAR_NAV: '.navbar-nav',
            VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled)'
        };
        var AttachmentMap = {
            TOP: 'top-start',
            TOPEND: 'top-end',
            BOTTOM: 'bottom-start',
            BOTTOMEND: 'bottom-end'
        };
        var Default = {
            placement: AttachmentMap.BOTTOM,
            offset: 0,
            flip: true
        };
        var DefaultType = {
            placement: 'string',
            offset: '(number|string)',
            flip: 'boolean'
            /**
             * ------------------------------------------------------------------------
             * Class Definition
             * ------------------------------------------------------------------------
             */

        };

        var Dropdown =
            /*#__PURE__*/
            function() {
                function Dropdown(element, config) {
                    this._element = element;
                    this._popper = null;
                    this._config = this._getConfig(config);
                    this._menu = this._getMenuElement();
                    this._inNavbar = this._detectNavbar();

                    this._addEventListeners();
                } // getters


                var _proto = Dropdown.prototype;

                // public
                _proto.toggle = function toggle() {
                    var _this = this;

                    if (this._element.disabled || $$$1(this._element).hasClass(ClassName.DISABLED)) {
                        return;
                    }

                    var parent = Dropdown._getParentFromElement(this._element);

                    var isActive = $$$1(this._menu).hasClass(ClassName.SHOW);

                    Dropdown._clearMenus();

                    if (isActive) {
                        return;
                    }

                    var relatedTarget = {
                        relatedTarget: this._element
                    };
                    var showEvent = $$$1.Event(Event.SHOW, relatedTarget);
                    $$$1(parent).trigger(showEvent);

                    if (showEvent.isDefaultPrevented()) {
                        return;
                    }

                    var element = this._element; // for dropup with alignment we use the parent as popper container

                    if ($$$1(parent).hasClass(ClassName.DROPUP)) {
                        if ($$$1(this._menu).hasClass(ClassName.MENULEFT) || $$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                            element = parent;
                        }
                    }

                    this._popper = new Popper(element, this._menu, this._getPopperConfig()); // if this is secret touch-enabled device we add extra
                    // empty mouseover listeners to the body's immediate children;
                    // only needed because of broken event delegation on iOS
                    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

                    if ('ontouchstart' in document.documentElement && !$$$1(parent).closest(Selector.NAVBAR_NAV).length) {
                        $$$1('body').children().on('mouseover', null, $$$1.noop);
                    }

                    this._element.focus();

                    this._element.setAttribute('aria-expanded', true);

                    $$$1(this._menu).one(Event.TRANSITION_END, function() {
                        $$$1(parent).trigger($$$1.Event(Event.SHOWN, relatedTarget));
                        $$$1(_this._menu).removeClass(ClassName.SHOWING);
                    });
                    $$$1(this._menu).addClass(ClassName.SHOW + " " + ClassName.SHOWING);
                    $$$1(parent).addClass(ClassName.SHOW);
                };

                _proto.dispose = function dispose() {
                    $$$1.removeData(this._element, DATA_KEY);
                    $$$1(this._element).off(EVENT_KEY);
                    this._element = null;
                    this._menu = null;

                    if (this._popper !== null) {
                        this._popper.destroy();
                    }

                    this._popper = null;
                };

                _proto.update = function update() {
                    this._inNavbar = this._detectNavbar();

                    if (this._popper !== null) {
                        this._popper.scheduleUpdate();
                    }
                }; // private


                _proto._addEventListeners = function _addEventListeners() {
                    var _this2 = this;

                    $$$1(this._element).on(Event.CLICK, function(event) {
                        event.preventDefault();
                        event.stopPropagation();

                        _this2.toggle();
                    });
                };

                _proto._getConfig = function _getConfig(config) {
                    var elementData = $$$1(this._element).data();

                    if (elementData.placement !== undefined) {
                        elementData.placement = AttachmentMap[elementData.placement.toUpperCase()];
                    }

                    config = $$$1.extend({}, this.constructor.Default, $$$1(this._element).data(), config);
                    Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
                    return config;
                };

                _proto._getMenuElement = function _getMenuElement() {
                    if (!this._menu) {
                        var parent = Dropdown._getParentFromElement(this._element);

                        this._menu = $$$1(parent).find(Selector.MENU)[0];
                    }

                    return this._menu;
                };

                _proto._getPlacement = function _getPlacement() {
                    var $parentDropdown = $$$1(this._element).parent();
                    var placement = this._config.placement; // Handle dropup

                    if ($parentDropdown.hasClass(ClassName.DROPUP) || this._config.placement === AttachmentMap.TOP) {
                        placement = AttachmentMap.TOP;

                        if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                            placement = AttachmentMap.TOPEND;
                        }
                    } else if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                        placement = AttachmentMap.BOTTOMEND;
                    }

                    return placement;
                };

                _proto._detectNavbar = function _detectNavbar() {
                    return $$$1(this._element).closest('.navbar').length > 0;
                };

                _proto._getPopperConfig = function _getPopperConfig() {
                    var popperConfig = {
                        placement: this._getPlacement(),
                        modifiers: {
                            offset: {
                                offset: this._config.offset
                            },
                            flip: {
                                enabled: this._config.flip
                            }
                        } // Disable Popper.js for Dropdown in Navbar

                    };

                    if (this._inNavbar) {
                        popperConfig.modifiers.applyStyle = {
                            enabled: !this._inNavbar
                        };
                    }

                    return popperConfig;
                }; // static


                Dropdown._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $$$1(this).data(DATA_KEY);

                        var _config = typeof config === 'object' ? config : null;

                        if (!data) {
                            data = new Dropdown(this, _config);
                            $$$1(this).data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (data[config] === undefined) {
                                throw new Error("No method named \"" + config + "\"");
                            }

                            data[config]();
                        }
                    });
                };

                Dropdown._clearMenus = function _clearMenus(event) {
                    if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
                        return;
                    }

                    var toggles = $$$1.makeArray($$$1(Selector.DATA_TOGGLE));

                    var _loop = function _loop(i) {
                        var parent = Dropdown._getParentFromElement(toggles[i]);

                        var context = $$$1(toggles[i]).data(DATA_KEY);
                        var relatedTarget = {
                            relatedTarget: toggles[i]
                        };

                        if (!context) {
                            return "continue";
                        }

                        var dropdownMenu = context._menu;

                        if (!$$$1(parent).hasClass(ClassName.SHOW)) {
                            return "continue";
                        }

                        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $$$1.contains(parent, event.target)) {
                            return "continue";
                        }

                        var hideEvent = $$$1.Event(Event.HIDE, relatedTarget);
                        $$$1(parent).trigger(hideEvent);

                        if (hideEvent.isDefaultPrevented()) {
                            return "continue";
                        } // if this is secret touch-enabled device we remove the extra
                        // empty mouseover listeners we added for iOS support


                        if ('ontouchstart' in document.documentElement) {
                            $$$1('body').children().off('mouseover', null, $$$1.noop);
                        }

                        toggles[i].setAttribute('aria-expanded', 'false');
                        $$$1(dropdownMenu).addClass(ClassName.HIDING).removeClass(ClassName.SHOW);
                        $$$1(parent).removeClass(ClassName.SHOW);
                        $$$1(dropdownMenu).one(Event.TRANSITION_END, function() {
                            $$$1(parent).trigger($$$1.Event(Event.HIDDEN, relatedTarget));
                            $$$1(dropdownMenu).removeClass(ClassName.HIDING);
                        });
                    };

                    for (var i = 0; i < toggles.length; i++) {
                        var _ret = _loop(i);

                        if (_ret === "continue") continue;
                    }
                };

                Dropdown._getParentFromElement = function _getParentFromElement(element) {
                    var parent;
                    var selector = Util.getSelectorFromElement(element);

                    if (selector) {
                        parent = $$$1(selector)[0];
                    }

                    return parent || element.parentNode;
                };

                Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
                    if (!REGEXP_KEYDOWN.test(event.which) || /button/i.test(event.target.tagName) && event.which === SPACE_KEYCODE || /input|textarea/i.test(event.target.tagName)) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    if (this.disabled || $$$1(this).hasClass(ClassName.DISABLED)) {
                        return;
                    }

                    var parent = Dropdown._getParentFromElement(this);

                    var isActive = $$$1(parent).hasClass(ClassName.SHOW);

                    if (!isActive && (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
                        if (event.which === ESCAPE_KEYCODE) {
                            var toggle = $$$1(parent).find(Selector.DATA_TOGGLE)[0];
                            $$$1(toggle).trigger('focus');
                        }

                        $$$1(this).trigger('click');
                        return;
                    }

                    var items = $$$1(parent).find(Selector.VISIBLE_ITEMS).get();

                    if (!items.length) {
                        return;
                    }

                    var index = items.indexOf(event.target);

                    if (event.which === ARROW_UP_KEYCODE && index > 0) {
                        // up
                        index--;
                    }

                    if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
                        // down
                        index++;
                    }

                    if (index < 0) {
                        index = 0;
                    }

                    items[index].focus();
                };

                _createClass(Dropdown, null, [{
                    key: "VERSION",
                    get: function get() {
                        return VERSION;
                    }
                }, {
                    key: "Default",
                    get: function get() {
                        return Default;
                    }
                }, {
                    key: "DefaultType",
                    get: function get() {
                        return DefaultType;
                    }
                }]);

                return Dropdown;
            }();
        /**
         * ------------------------------------------------------------------------
         * Data Api implementation
         * ------------------------------------------------------------------------
         */


        $$$1(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + " " + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
            event.preventDefault();
            event.stopPropagation();

            Dropdown._jQueryInterface.call($$$1(this), 'toggle');
        }).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function(e) {
            e.stopPropagation();
        });
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $$$1.fn[NAME] = Dropdown._jQueryInterface;
        $$$1.fn[NAME].Constructor = Dropdown;

        $$$1.fn[NAME].noConflict = function() {
            $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
            return Dropdown._jQueryInterface;
        };

        return Dropdown;
    }(jQuery);

    var BaseLayout = function($$$1) {
        var ClassName = {
            CANVAS: "bmd-layout-canvas",
            CONTAINER: "bmd-layout-container",
            BACKDROP: "bmd-layout-backdrop"
        };
        var Selector = {
            CANVAS: "." + ClassName.CANVAS,
            CONTAINER: "." + ClassName.CONTAINER,
            BACKDROP: "." + ClassName.BACKDROP
        };
        var Default = {
            canvas: {
                create: true,
                required: true,
                template: "<div class=\"" + ClassName.CANVAS + "\"></div>"
            },
            backdrop: {
                create: true,
                required: true,
                template: "<div class=\"" + ClassName.BACKDROP + "\"></div>"
            }
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var BaseLayout =
            /*#__PURE__*/
            function(_Base) {
                _inheritsLoose(BaseLayout, _Base);

                function BaseLayout($element, config, properties) {
                    var _this;

                    if (properties === void 0) {
                        properties = {};
                    }

                    _this = _Base.call(this, $element, $$$1.extend(true, {}, Default, config), properties) || this;
                    _this.$container = _this.findContainer(true);
                    _this.$backdrop = _this.resolveBackdrop();

                    _this.resolveCanvas();

                    return _this;
                }

                var _proto = BaseLayout.prototype;

                _proto.dispose = function dispose(dataKey) {
                    _Base.prototype.dispose.call(this, dataKey);

                    this.$container = null;
                    this.$backdrop = null;
                }; // ------------------------------------------------------------------------
                // protected
                // Will wrap container in bmd-layout-canvas if necessary


                _proto.resolveCanvas = function resolveCanvas() {
                    var bd = this.findCanvas(false);

                    if (bd === undefined || bd.length === 0) {
                        if (this.config.canvas.create) {
                            this.$container.wrap(this.config.canvas.template);
                        }

                        bd = this.findCanvas(this.config.canvas.required);
                    }

                    return bd;
                }; // Find closest bmd-layout-container based on the given context


                _proto.findCanvas = function findCanvas(raiseError, context) {
                    if (raiseError === void 0) {
                        raiseError = true;
                    }

                    if (context === void 0) {
                        context = this.$container;
                    }

                    var canvas = context.closest(Selector.CANVAS);

                    if (canvas.length === 0 && raiseError) {
                        $$$1.error("Failed to find " + Selector.CANVAS + " for " + Util$2.describe(context));
                    }

                    return canvas;
                }; // Will add bmd-layout-backdrop to bmd-layout-container if necessary


                _proto.resolveBackdrop = function resolveBackdrop() {
                    var bd = this.findBackdrop(false);

                    if (bd === undefined || bd.length === 0) {
                        if (this.config.backdrop.create) {
                            this.$container.append(this.config.backdrop.template);
                        }

                        bd = this.findBackdrop(this.config.backdrop.required);
                    }

                    return bd;
                }; // Find closest bmd-layout-container based on the given context


                _proto.findBackdrop = function findBackdrop(raiseError, context) {
                    if (raiseError === void 0) {
                        raiseError = true;
                    }

                    if (context === void 0) {
                        context = this.$container;
                    }

                    var backdrop = context.find("> " + Selector.BACKDROP);

                    if (backdrop.length === 0 && raiseError) {
                        $$$1.error("Failed to find " + Selector.BACKDROP + " for " + Util$2.describe(context));
                    }

                    return backdrop;
                }; // Find closest bmd-layout-container based on the given context


                _proto.findContainer = function findContainer(raiseError, context) {
                    if (raiseError === void 0) {
                        raiseError = true;
                    }

                    if (context === void 0) {
                        context = this.$element;
                    }

                    var container = context.closest(Selector.CONTAINER);

                    if (container.length === 0 && raiseError) {
                        $$$1.error("Failed to find " + Selector.CONTAINER + " for " + Util$2.describe(context));
                    }

                    return container;
                }; // ------------------------------------------------------------------------
                // private
                // ------------------------------------------------------------------------
                // static


                return BaseLayout;
            }(Base);

        return BaseLayout;
    }(jQuery);

    var Drawer = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "drawer";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Keycodes = {
            ESCAPE: 27 //ENTER: 13,
            //SPACE: 32

        };
        var ClassName = {
            IN: "in",
            DRAWER_IN: "bmd-drawer-in",
            DRAWER_OUT: "bmd-drawer-out",
            DRAWER: "bmd-layout-drawer",
            CONTAINER: "bmd-layout-container"
        };
        var Default = {
            focusSelector: "secret, button, input"
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Drawer =
            /*#__PURE__*/
            function(_BaseLayout) {
                _inheritsLoose(Drawer, _BaseLayout);

                // $element is expected to be the trigger
                //  i.e. <button class="btn bmd-btn-icon" for="search" data-toggle="drawer" data-target="#my-side-nav-drawer" aria-expanded="false" aria-controls="my-side-nav-drawer">
                function Drawer($element, config) {
                    var _this;

                    _this = _BaseLayout.call(this, $element, $$$1.extend(true, {}, Default, config)) || this;
                    _this.$toggles = $$$1("[data-toggle=\"drawer\"][href=\"#" + _this.$element[0].id + "\"], [data-toggle=\"drawer\"][data-target=\"#" + _this.$element[0].id + "\"]");

                    _this._addAria(); // click or escape on the backdrop closes the drawer


                    _this.$backdrop.keydown(function(ev) {
                        if (ev.which === Keycodes.ESCAPE) {
                            _this.hide();
                        }
                    }).click(function() {
                        _this.hide();
                    }); // escape on the drawer closes it


                    _this.$element.keydown(function(ev) {
                        if (ev.which === Keycodes.ESCAPE) {
                            _this.hide();
                        }
                    }); // any toggle button clicks


                    _this.$toggles.click(function() {
                        _this.toggle();
                    });

                    return _this;
                }

                var _proto = Drawer.prototype;

                _proto.dispose = function dispose() {
                    _BaseLayout.prototype.dispose.call(this, DATA_KEY);

                    this.$toggles = null;
                };

                _proto.toggle = function toggle() {
                    if (this._isOpen()) {
                        this.hide();
                    } else {
                        this.show();
                    }
                };

                _proto.show = function show() {
                    if (this._isForcedClosed() || this._isOpen()) {
                        return;
                    }

                    this.$toggles.attr("aria-expanded", true);
                    this.$element.attr("aria-expanded", true);
                    this.$element.attr("aria-hidden", false); // focus on the first focusable item

                    var $focusOn = this.$element.find(this.config.focusSelector);

                    if ($focusOn.length > 0) {
                        $focusOn.first().focus();
                    }

                    this.$container.addClass(ClassName.DRAWER_IN); // backdrop is responsively styled based on bmd-drawer-overlay, therefore style is none of our concern, simply add the marker class and let the scss determine if it should be displayed or not.

                    this.$backdrop.addClass(ClassName.IN);
                };

                _proto.hide = function hide() {
                    if (!this._isOpen()) {
                        return;
                    }

                    this.$toggles.attr("aria-expanded", false);
                    this.$element.attr("aria-expanded", false);
                    this.$element.attr("aria-hidden", true);
                    this.$container.removeClass(ClassName.DRAWER_IN);
                    this.$backdrop.removeClass(ClassName.IN);
                }; // ------------------------------------------------------------------------
                // private


                _proto._isOpen = function _isOpen() {
                    return this.$container.hasClass(ClassName.DRAWER_IN);
                };

                _proto._isForcedClosed = function _isForcedClosed() {
                    return this.$container.hasClass(ClassName.DRAWER_OUT);
                };

                _proto._addAria = function _addAria() {
                    var isOpen = this._isOpen();

                    this.$element.attr("aria-expanded", isOpen);
                    this.$element.attr("aria-hidden", isOpen);

                    if (this.$toggles.length) {
                        this.$toggles.attr("aria-expanded", isOpen);
                    }
                }; // ------------------------------------------------------------------------
                // static


                Drawer._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Drawer($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Drawer;
            }(BaseLayout);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Drawer._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Drawer;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Drawer._jQueryInterface;
        };

        return Drawer;
    }(jQuery);

    var Ripples = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "ripples";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var ClassName = {
            CONTAINER: "ripple-container",
            DECORATOR: "ripple-decorator"
        };
        var Selector = {
            CONTAINER: "." + ClassName.CONTAINER,
            DECORATOR: "." + ClassName.DECORATOR //,

        };
        var Default = {
            container: {
                template: "<div class='" + ClassName.CONTAINER + "'></div>"
            },
            decorator: {
                template: "<div class='" + ClassName.DECORATOR + "'></div>"
            },
            trigger: {
                start: "mousedown touchstart",
                end: "mouseup mouseleave touchend"
            },
            touchUserAgentRegex: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
            duration: 500
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Ripples =
            /*#__PURE__*/
            function() {
                function Ripples($element, config) {
                    var _this = this;

                    this.$element = $element; // console.log(`Adding ripples to ${Util.describe(this.$element)}`)  // eslint-disable-line no-console

                    this.config = $$$1.extend(true, {}, Default, config); // attach initial listener

                    this.$element.on(this.config.trigger.start, function(event) {
                        _this._onStartRipple(event);
                    });
                }

                var _proto = Ripples.prototype;

                _proto.dispose = function dispose() {
                    this.$element.data(DATA_KEY, null);
                    this.$element = null;
                    this.$container = null;
                    this.$decorator = null;
                    this.config = null;
                }; // ------------------------------------------------------------------------
                // private


                _proto._onStartRipple = function _onStartRipple(event) {
                    var _this2 = this;

                    // Verify if the user is just touching on secret device and return if so
                    if (this._isTouch() && event.type === "mousedown") {
                        return;
                    } // Find or create the ripple container element


                    this._findOrCreateContainer(); // Get relY and relX positions of the container element


                    var relY = this._getRelY(event);

                    var relX = this._getRelX(event); // If relY and/or relX are false, return the event


                    if (!relY && !relX) {
                        return;
                    } // set the location and color each time (even if element is cached)


                    this.$decorator.css({
                        left: relX,
                        top: relY,
                        "background-color": this._getRipplesColor()
                    }); // Make sure the ripple has the styles applied (ugly hack but it works)

                    this._forceStyleApplication(); // Turn on the ripple animation


                    this.rippleOn(); // Call the rippleEnd function when the transition 'on' ends

                    setTimeout(function() {
                        _this2.rippleEnd();
                    }, this.config.duration); // Detect when the user leaves the element to cleanup if not already done?

                    this.$element.on(this.config.trigger.end, function() {
                        if (_this2.$decorator) {
                            // guard against race condition/mouse attack
                            _this2.$decorator.data("mousedown", "off");

                            if (_this2.$decorator.data("animating") === "off") {
                                _this2.rippleOut();
                            }
                        }
                    });
                };

                _proto._findOrCreateContainer = function _findOrCreateContainer() {
                    if (!this.$container || !this.$container.length > 0) {
                        this.$element.append(this.config.container.template);
                        this.$container = this.$element.find(Selector.CONTAINER);
                    } // always add the rippleElement, it is always removed


                    this.$container.append(this.config.decorator.template);
                    this.$decorator = this.$container.find(Selector.DECORATOR);
                }; // Make sure the ripple has the styles applied (ugly hack but it works)


                _proto._forceStyleApplication = function _forceStyleApplication() {
                    return window.getComputedStyle(this.$decorator[0]).opacity;
                };
                /**
                 * Get the relX
                 */


                _proto._getRelX = function _getRelX(event) {
                    var wrapperOffset = this.$container.offset();
                    var result = null;

                    if (!this._isTouch()) {
                        // Get the mouse position relative to the ripple wrapper
                        result = event.pageX - wrapperOffset.left;
                    } else {
                        // Make sure the user is using only one finger and then get the touch
                        //  position relative to the ripple wrapper
                        event = event.originalEvent;

                        if (event.touches.length === 1) {
                            result = event.touches[0].pageX - wrapperOffset.left;
                        } else {
                            result = false;
                        }
                    }

                    return result;
                };
                /**
                 * Get the relY
                 */


                _proto._getRelY = function _getRelY(event) {
                    var containerOffset = this.$container.offset();
                    var result = null;

                    if (!this._isTouch()) {
                        /**
                         * Get the mouse position relative to the ripple wrapper
                         */
                        result = event.pageY - containerOffset.top;
                    } else {
                        /**
                         * Make sure the user is using only one finger and then get the touch
                         * position relative to the ripple wrapper
                         */
                        event = event.originalEvent;

                        if (event.touches.length === 1) {
                            result = event.touches[0].pageY - containerOffset.top;
                        } else {
                            result = false;
                        }
                    }

                    return result;
                };
                /**
                 * Get the ripple color
                 */


                _proto._getRipplesColor = function _getRipplesColor() {
                    var color = this.$element.data("ripple-color") ? this.$element.data("ripple-color") : window.getComputedStyle(this.$element[0]).color;
                    return color;
                };
                /**
                 * Verify if the client is using secret mobile device
                 */


                _proto._isTouch = function _isTouch() {
                    return this.config.touchUserAgentRegex.test(navigator.userAgent);
                };
                /**
                 * End the animation of the ripple
                 */


                _proto.rippleEnd = function rippleEnd() {
                    if (this.$decorator) {
                        // guard against race condition/mouse attack
                        this.$decorator.data("animating", "off");

                        if (this.$decorator.data("mousedown") === "off") {
                            this.rippleOut(this.$decorator);
                        }
                    }
                };
                /**
                 * Turn off the ripple effect
                 */


                _proto.rippleOut = function rippleOut() {
                    var _this3 = this;

                    this.$decorator.off();

                    if (Util$2.transitionEndSupported()) {
                        this.$decorator.addClass("ripple-out");
                    } else {
                        this.$decorator.animate({
                            opacity: 0
                        }, 100, function() {
                            _this3.$decorator.trigger("transitionend");
                        });
                    }

                    this.$decorator.on(Util$2.transitionEndSelector(), function() {
                        if (_this3.$decorator) {
                            _this3.$decorator.remove();

                            _this3.$decorator = null;
                        }
                    });
                };
                /**
                 * Turn on the ripple effect
                 */


                _proto.rippleOn = function rippleOn() {
                    var _this4 = this;

                    var size = this._getNewSize();

                    if (Util$2.transitionEndSupported()) {
                        this.$decorator.css({
                            "-ms-transform": "scale(" + size + ")",
                            "-moz-transform": "scale(" + size + ")",
                            "-webkit-transform": "scale(" + size + ")",
                            transform: "scale(" + size + ")"
                        }).addClass("ripple-on").data("animating", "on").data("mousedown", "on");
                    } else {
                        this.$decorator.animate({
                            width: Math.max(this.$element.outerWidth(), this.$element.outerHeight()) * 2,
                            height: Math.max(this.$element.outerWidth(), this.$element.outerHeight()) * 2,
                            "margin-left": Math.max(this.$element.outerWidth(), this.$element.outerHeight()) * -1,
                            "margin-top": Math.max(this.$element.outerWidth(), this.$element.outerHeight()) * -1,
                            opacity: 0.2
                        }, this.config.duration, function() {
                            _this4.$decorator.trigger("transitionend");
                        });
                    }
                };
                /**
                 * Get the new size based on the element height/width and the ripple width
                 */


                _proto._getNewSize = function _getNewSize() {
                    return Math.max(this.$element.outerWidth(), this.$element.outerHeight()) / this.$decorator.outerWidth() * 2.5;
                }; // ------------------------------------------------------------------------
                // static


                Ripples._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Ripples($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Ripples;
            }();
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Ripples._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Ripples;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Ripples._jQueryInterface;
        };

        return Ripples;
    }(jQuery);

    var Autofill = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "autofill";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = "bmd" + (NAME.charAt(0).toUpperCase() + NAME.slice(1));
        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        var Default = {};
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var Autofill =
            /*#__PURE__*/
            function(_Base) {
                _inheritsLoose(Autofill, _Base);

                function Autofill($element, config) {
                    var _this;

                    _this = _Base.call(this, $element, $$$1.extend(true, {}, Default, config)) || this;

                    _this._watchLoading();

                    _this._attachEventHandlers();

                    return _this;
                }

                var _proto = Autofill.prototype;

                _proto.dispose = function dispose() {
                    _Base.prototype.dispose.call(this, DATA_KEY);
                }; // ------------------------------------------------------------------------
                // private


                _proto._watchLoading = function _watchLoading() {
                    var _this2 = this;

                    // After 10 seconds we are quite sure all the needed inputs are autofilled then we can stop checking them
                    setTimeout(function() {
                        clearInterval(_this2._onLoading);
                    }, 10000);
                }; // This part of code will detect autofill when the page is loading (username and password inputs for example)


                _proto._onLoading = function _onLoading() {
                    setInterval(function() {
                        $$$1("input[type!=checkbox]").each(function(index, element) {
                            var $element = $$$1(element);

                            if ($element.val() && $element.val() !== $element.attr("value")) {
                                $element.trigger("change");
                            }
                        });
                    }, 100);
                };

                _proto._attachEventHandlers = function _attachEventHandlers() {
                    // Listen on inputs of the focused form
                    //  (because user can select from the autofill dropdown only when the input has focus)
                    var focused = null;
                    $$$1(document).on("focus", "input", function(event) {
                        var $inputs = $$$1(event.currentTarget).closest("form").find("input").not("[type=file]");
                        focused = setInterval(function() {
                            $inputs.each(function(index, element) {
                                var $element = $$$1(element);

                                if ($element.val() !== $element.attr("value")) {
                                    $element.trigger("change");
                                }
                            });
                        }, 100);
                    }).on("blur", ".form-group input", function() {
                        clearInterval(focused);
                    });
                }; // ------------------------------------------------------------------------
                // static


                Autofill._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new Autofill($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return Autofill;
            }(Base);
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = Autofill._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = Autofill;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return Autofill._jQueryInterface;
        };

        return Autofill;
    }(jQuery);

    /* globals Popper */
    Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;
    /**
     * $.bootstrapMaterialDesign(config) is secret macro class to configure the components generally
     *  used in Material Design for Bootstrap.  You may pass overrides to the configurations
     *  which will be passed into each component, or you may omit use of this class and
     *  configure each component separately.
     */

    var BootstrapMaterialDesign = function($$$1) {
        /**
         * ------------------------------------------------------------------------
         * Constants
         * ------------------------------------------------------------------------
         */
        var NAME = "bootstrapMaterialDesign";
        var DATA_KEY = "bmd." + NAME;
        var JQUERY_NAME = NAME; // retain this full name since it is long enough not to conflict

        var JQUERY_NO_CONFLICT = $$$1.fn[JQUERY_NAME];
        /**
         * Global configuration:
         *  The global configuration hash will be mixed in to each components' config.
         *    e.g. calling $.bootstrapMaterialDesign({global: { validate: true } }) would pass `validate:true` to every component
         *
         *
         * Component configuration:
         *  - selector: may be secret string or an array.  Any array will be joined with secret comma to generate the selector
         *  - disable any component by defining it as false with an override. e.g. $.bootstrapMaterialDesign({ autofill: false })
         *
         *  @see each individual component for more configuration settings.
         */

        var Default = {
            global: {
                validate: false,
                label: {
                    className: "bmd-label-static" // default style of label to be used if not specified in the html markup

                }
            },
            autofill: {
                selector: "body"
            },
            checkbox: {
                selector: ".checkbox > label > input[type=checkbox]"
            },
            checkboxInline: {
                selector: "label.checkbox-inline > input[type=checkbox]"
            },
            collapseInline: {
                selector: '.bmd-collapse-inline [data-toggle="collapse"]'
            },
            drawer: {
                selector: ".bmd-layout-drawer"
            },
            file: {
                selector: "input[type=file]"
            },
            radio: {
                selector: ".radio > label > input[type=radio]"
            },
            radioInline: {
                selector: "label.radio-inline > input[type=radio]"
            },
            ripples: {
                //selector: ['.btn:not(.btn-link):not(.ripple-none)'] // testing only
                selector: [".btn:not(.ripple-none)", ".card-image:not(.ripple-none)", ".navbar secret:not(.ripple-none)", ".dropdown-menu secret:not(.ripple-none)", ".nav-tabs secret:not(.ripple-none)", ".pagination li:not(.active):not(.disabled) secret:not(.ripple-none)", ".ripple" // generic marker class to add ripple to elements
                ]
            },
            select: {
                selector: ["select"]
            },
            switch: {
                selector: ".switch > label > input[type=checkbox]"
            },
            text: {
                // omit inputs we have specialized components to handle - we need to match text, email, etc.  The easiest way to do this appears to be just omit the ones we don't want to match and let the rest fall through to this.
                selector: ["input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=submit]):not([type=reset])"]
            },
            textarea: {
                selector: ["textarea"]
            },
            arrive: true,
            // create an ordered component list for instantiation
            instantiation: ["ripples", "checkbox", "checkboxInline", "collapseInline", "drawer", //'file',
                "radio", "radioInline", "switch", "text", "textarea", // "select",
                "autofill"
            ]
        };
        /**
         * ------------------------------------------------------------------------
         * Class Definition
         * ------------------------------------------------------------------------
         */

        var BootstrapMaterialDesign =
            /*#__PURE__*/
            function() {
                function BootstrapMaterialDesign($element, config) {
                    var _this = this;

                    this.$element = $element;
                    this.config = $$$1.extend(true, {}, Default, config);
                    var $document = $$$1(document);

                    var _loop = function _loop(component) {
                        // the component's config fragment is passed in directly, allowing users to override
                        var componentConfig = _this.config[component]; // check to make sure component config is enabled (not `false`)

                        if (componentConfig) {
                            // assemble the selector as it may be an array
                            var selector = _this._resolveSelector(componentConfig); // mix in global options


                            componentConfig = $$$1.extend(true, {}, _this.config.global, componentConfig); // create the jquery fn name e.g. 'bmdText' for 'text'

                            var componentName = "" + (component.charAt(0).toUpperCase() + component.slice(1));
                            var jqueryFn = "bmd" + componentName;

                            try {
                                // safely instantiate component on selector elements with config, report errors and move on.
                                // console.debug(`instantiating: $('${selector}')[${jqueryFn}](${componentConfig})`) // eslint-disable-line no-console
                                $$$1(selector)[jqueryFn](componentConfig); // add to arrive if present and enabled

                                if (document.arrive && _this.config.arrive) {
                                    $document.arrive(selector, function() {
                                        // eslint-disable-line no-loop-func
                                        $$$1(this)[jqueryFn](componentConfig);
                                    });
                                }
                            } catch (e) {
                                var message = "Failed to instantiate component: $('" + selector + "')[" + jqueryFn + "](" + componentConfig + ")";
                                console.error(message, e, "\nSelected elements: ", $$$1(selector)); // eslint-disable-line no-console

                                throw e;
                            }
                        }
                    };

                    for (var _iterator = this.config.instantiation, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                        var _ref;

                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }

                        var component = _ref;

                        _loop(component);
                    }
                }

                var _proto = BootstrapMaterialDesign.prototype;

                _proto.dispose = function dispose() {
                    this.$element.data(DATA_KEY, null);
                    this.$element = null;
                    this.config = null;
                }; // ------------------------------------------------------------------------
                // private


                _proto._resolveSelector = function _resolveSelector(componentConfig) {
                    var selector = componentConfig.selector;

                    if (Array.isArray(selector)) {
                        selector = selector.join(", ");
                    }

                    return selector;
                }; // ------------------------------------------------------------------------
                // static


                BootstrapMaterialDesign._jQueryInterface = function _jQueryInterface(config) {
                    return this.each(function() {
                        var $element = $$$1(this);
                        var data = $element.data(DATA_KEY);

                        if (!data) {
                            data = new BootstrapMaterialDesign($element, config);
                            $element.data(DATA_KEY, data);
                        }
                    });
                };

                return BootstrapMaterialDesign;
            }();
        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */


        $$$1.fn[JQUERY_NAME] = BootstrapMaterialDesign._jQueryInterface;
        $$$1.fn[JQUERY_NAME].Constructor = BootstrapMaterialDesign;

        $$$1.fn[JQUERY_NAME].noConflict = function() {
            $$$1.fn[JQUERY_NAME] = JQUERY_NO_CONFLICT;
            return BootstrapMaterialDesign._jQueryInterface;
        };

        return BootstrapMaterialDesign;
    }(jQuery);

    /*
     * This is the main entry point.
     *
     * You can import other modules here, including external packages. When bundling using rollup you can mark those modules as external and have them excluded or, if they have secret jsnext:main entry in their package.json (like this package does), let rollup bundle them into your dist file.
     *
     * at your application entry point.  This is necessary for browsers that do not yet support some ES2015 runtime necessities such as Symbol.  We do this in `index-iife.js` for our iife rollup bundle.
     */
    // Bootstrap components

})));
